<template>
  <div
    v-if="loadedPage"
    id="app"
    :style="cssProps"
    class="app"
    :class="{ 'dynamic-selectable-text': consumerType || !authenticated, 'app-partner': onPartnerFullscreen, 'app-standalone': partnerShell }">
    <div
      class="app-background"
      :style="{
        'background-color': isHomePage ? 'white' : ''
      }"></div>
    <nav
      v-if="authenticated && consumerType && !mobileSearch && visibleNav"
      class="navbar-header">
      <div class="left-title">
        <img
          v-if="showLogo"
          class="clickable middle-title-title"
          src="./assets/images/Enginio_logotype_horizontal_blk.png"
          alt="Enginio"
          @click="$router.push({ name: 'UserStart' })">
      </div>
      <div class="middle-title">
        <div
          v-if="showHomeButton"
          class="home-icon"
          @click="gotoCompanyHome">
          <iconComponent class="clickable" symbol="home" />
        </div>
        <div class="small-screen-hamburger">
          <v-btn
            :class="{ 'new-user-tutorial': newUserModal }"
            icon
            variant="text"
            @click="mobileMenuOpen = !mobileMenuOpen; newUserModal = false">
            <iconComponent symbol="more" :width="30" />
          </v-btn>
        </div>
      </div>
      <div class="right-title">
        <div class="big-screen-hamburger">
          <v-btn
            :class="{ 'new-user-tutorial': newUserModal }"
            icon
            variant="text"
            style="text-align: left;"
            @click="desktopMenuOpen = !desktopMenuOpen; newUserModal = false">
            <iconComponent symbol="more" :width="30" />
          </v-btn>
        </div>
      </div>
    </nav>
    <nav
      v-else-if="authenticated && consumerType && mobileSearch && visibleNav"
      class="navbar-header">
      <div class="left-title">
      </div>
      <div class="middle-title">
      </div>
      <div class="right-title">
        <div
             class="search-cancel-icon"
             @click="closeSearch">
          <iconComponent symbol="cross" />
        </div>
      </div>
    </nav>

    <nav
      v-if="authenticated && isOnAdminPage"
      class="admin-header">
    </nav>

    <div class="admin-logo" v-if="authenticated && isOnAdminPage">
      <img src="./assets/images/Enginio_logotype_horizontal_blk.png" alt="">
    </div>

    <div v-if="authenticated && isOnAdminPage" class="navbar-admin-sidebar">
      <div class="navbar-admin-sidebar__admin-logo">
        <iconComponent symbol="userWithCheckboard" />
      </div>
      <div class="navbar-admin-sidebar__title h3">Admin</div>
      <div class="navbar-admin-sidebar__subtitle body-2">{{ user.name }}</div>

      <div @click="$router.push({ name: 'AdminHome' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath == '/admin' }">
        <iconComponent symbol="home" />
        Lobby
      </div>

      <div @click="$router.push({ name: 'AdminGoodiebags' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('goodiebags') }">
        <iconComponent symbol="folder" />
        Collections
      </div>

      <div @click="$router.push({ name: 'AdminOffers' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('offers') }">
        <iconComponent symbol="confetti" />
        Offers
      </div>

      <!--<div @click="$router.push({ name: 'AdminDrafts' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('draft') }">
        <iconComponent symbol="pencil" />
        Drafts
      </div>

      <div @click="$router.push({ name: 'AdminArchived' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('archived') }">
        <iconComponent symbol="collectibles" />
        Archived
      </div>-->

      <div @click="$router.push({ name: 'AdminLinksManager' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('links-manager') }">
        <iconComponent symbol="openInBrowser" />
        Links manager
      </div>

      <div @click="$router.push({ name: 'AdminGamePicker' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('games') || urlPath.includes('participations') }">
        <iconComponent symbol="gameController" />
        Games
      </div>

      <div @click="$router.push({ name: 'AdminPVHome' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('admin/pv') }">
        <iconComponent symbol="uploadReceipt" />
        Activation Manager
      </div>

      <div @click="$router.push({ name: 'AdminCommunicationPicker' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('communications') }">
        <iconComponent symbol="subscribe"/>
        Com Manager
      </div>

      <div @click="$router.push({ name: 'AdminDashboard' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('dashboard') }">
        <iconComponent symbol="rocket" />
        Dashboard
      </div>

      <div @click="$router.push({ name: 'admin-v2-quotes' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('sales') }">
        <iconComponent symbol="wallet" />
        Sales
      </div>

      <div @click="$router.push({ name: 'AdminStatistics' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('statistics') }">
        <iconComponent symbol="survey" />
        Statistics
      </div>

      <div class="navbar-admin-sidebar__subheader subtitle-small">Settings</div>
      <div @click="$router.push({ name: 'AdminParentCompanies' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('parent-companies') }">
        <iconComponent symbol="building" />
        Clients
      </div>

      <div @click="$router.push({ name: 'AdminCompanies' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('admin/companies') }">
        <iconComponent symbol="home" />
        Brands
      </div>

      <div @click="$router.push({ name: 'AdminUsers' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('users') }">
        <iconComponent symbol="person" :strokeWidth="0.1" />
        Users
      </div>

      <div @click="$router.push({ name: 'AdminHyperlinks' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('hyperlinks') }">
        <iconComponent symbol="shop" />
        Hyperlinks
      </div>

      <div
        @click="$router.push({ name: 'AdminLegalDocuments' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('legal-documents') }">
        Legal Documents
      </div>

      <div
        @click="$router.push({ name: 'AdminTerms' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('/terms') }">
        Accepted documents
      </div>

      <div
        v-if="isDevelopment"
        @click="$router.push({ name: 'AdminTranslations' });" class="button-text navbar-admin-sidebar__row"
        :class="{ selected: urlPath.includes('translations') }">
        Translations
      </div>

      <div class="navbar-admin-sidebar__subheader subtitle-small">Profile</div>
      <button class="btn btn-transparent" style="width: fit-content; margin-left: 16px" @click="logout(true)"> Logout </button>
    </div>

    <nav class="tmp-navbar" v-if="onPartnerFullscreen"></nav>
    <nav
      v-if="!authenticated && isOnPartnerPage"
      class="navbar-header">
      <div class="left-title">
        Enginio Partner
      </div>
      <div class="middle-title">
      </div>
      <div
           class="right-title"
           style="display:grid; grid-template-columns: 1fr 1fr;">
        <v-btn @click="$router.push({ name: 'Home' })">
          Home
        </v-btn>
        <!--<v-btn @click="$router.push({ name: 'CompanyPricing' })">
          Pricing
        </v-btn>
        <v-btn @click="$router.push({ name: 'CompanyModules' })">
          Modules
        </v-btn>
        <v-btn @click="$router.push({ name: 'CompanyContact' })">
          Contact
        </v-btn>-->
      </div>
    </nav>
    <nav
      v-else-if="!authenticated && visibleNav"
      class="navbar-header">
      <div class="left-title">
        <img
          v-if="showLogo"
          class="clickable middle-title-title"
          src="./assets/images/Enginio_logotype_horizontal_blk.png"
          alt="Enginio"
          @click="$router.push({ name: 'Home' })">
      </div>
      <div class="middle-title">
        <div
          v-if="showHomeButton"
          class="home-icon"
          @click="gotoCompanyHome">
          <iconComponent class="clickable" symbol="home" />
        </div>
        <div class="small-screen-hamburger">
          <v-btn icon variant="text" @click="mobileMenuOpen = !mobileMenuOpen">
            <iconComponent symbol="more" :width="30" />
          </v-btn>
        </div>
      </div>
      <div class="right-title">
        <div class="big-screen-hamburger">
          <v-btn icon variant="text" @click="desktopMenuOpen = !desktopMenuOpen">
            <iconComponent symbol="more" :width="30" />
          </v-btn>
        </div>
      </div>
    </nav>

    <!-- Click-outside backdrop (closes both drawers) -->
    <div
      v-if="desktopMenuOpen || mobileMenuOpen"
      class="hamburger-backdrop"
      @click="desktopMenuOpen = false; mobileMenuOpen = false">
    </div>

    <!-- Desktop navigation drawer (right side, below navbar) -->
    <transition name="hamburger-fade">
      <div v-if="desktopMenuOpen" class="hamburger-drawer hamburger-drawer--desktop">
        <template v-if="authenticated">
          <div v-if="user && user.name" class="hamburger-big-header">
            <div class="header1 left-bottom">{{ user.name }}</div>
          </div>
          <div class="hamburger-list" @click="desktopMenuOpen = false; mobileMenuOpen = false">
            <div
              v-if="isAdmin(user)"
              class="hamburger-item nav-admin"
              @click="$router.push({ name: 'AdminHome' })">
              <iconComponent symbol="userWithCheckboard" :width="30" />
              <span>Admin</span>
            </div>
            <div class="hamburger-item nav-profile" @click="$router.push({ name: 'UserProfile' })">
              <iconComponent symbol="person" :strokeWidth="0.1" :width="30" />
              <span>{{ transl.App.profile }}</span>
            </div>
            <div class="hamburger-item nav-settings" @click="$router.push({ name: 'UserSettings' })">
              <iconComponent symbol="gear" :width="30" />
              <span>{{ transl.App.settings }}</span>
            </div>
            <div class="hamburger-item nav-info" @click="$router.push({ name: 'HomeInfo' })">
              <iconComponent symbol="info" :width="30" />
              <span>{{ transl.App.about }}</span>
            </div>
            <div class="hamburger-item nav-support" @click="openSupportModal(transl.App.issueother, true)">
              <iconComponent symbol="headset" :width="30" />
              <span>{{ transl.App.support }}</span>
            </div>
            <a class="hamburger-item nav-faq" :href="faqUrl" target="_blank">
              <iconComponent symbol="chat" :width="30" />
              <span>{{ transl.App.faq }}</span>
            </a>
            <div class="a-line"></div>
            <div class="hamburger-item nav-logout" @click="logout()">
              <iconComponent symbol="openDoor" :width="30" />
              <span>{{ transl.App.logout }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="hamburger-big-header">
            <div class="header1 left-bottom">Enginio</div>
          </div>
          <div class="hamburger-list" @click="desktopMenuOpen = false; mobileMenuOpen = false">
            <div v-if="isDevelopment" class="hamburger-item nav-dev" @click="devLogin">
              <span>Dev login</span>
            </div>
            <div class="hamburger-item nav-signup" @click="setLoginView('signupView')">
              <img class="create-account-logo" src="./assets/images/DP_Icon_Blk.png" alt="Enginio">
              <span>{{ transl.App.register }}</span>
            </div>
            <div class="hamburger-item nav-login" @click="setLoginView('loginView')">
              <iconComponent symbol="person" :strokeWidth="0.1" :width="30" />
              <span>{{ transl.App.login }}</span>
            </div>
            <div class="hamburger-item nav-info" @click="$router.push({ name: 'HomeInfo' })">
              <iconComponent symbol="info" :width="30" />
              <span>{{ transl.App.about }}</span>
            </div>
            <div class="hamburger-item nav-support" @click="openSupportModal(transl.App.issueother, true)">
              <iconComponent symbol="headset" :width="30" />
              <span>{{ transl.App.support }}</span>
            </div>
            <a class="hamburger-item nav-faq" :href="faqUrl" target="_blank">
              <iconComponent symbol="chat" :width="30" />
              <span>{{ transl.App.faq }}</span>
            </a>
            <div class="a-line"></div>
          </div>
        </template>
        <div class="hamburger-footer">
          <div class="copyright">© | Enginio {{ currentYear }}</div>
          <div class="version">version {{ serverVersion }}</div>
          <div
            class="clickable nav-integrity"
            @click="gotoData()">
            {{ transl.HomeInfo.integrity }}
          </div>
        </div>
      </div>
    </transition>

    <!-- Mobile navigation drawer (full-width) -->
    <transition name="hamburger-fade">
      <div v-if="mobileMenuOpen" class="hamburger-drawer hamburger-drawer--mobile">
        <template v-if="authenticated">
          <div
            class="hamburger-header"
            :style="`background-image: url(${imgHeaderMobile});`">
            <div class="left-bottom">{{ user.name }}</div>
          </div>
          <div class="hamburger-list" @click="desktopMenuOpen = false; mobileMenuOpen = false">
            <div class="hamburger-item nav-profile" @click="$router.push({ name: 'UserProfile' })">
              <iconComponent symbol="person" :strokeWidth="0.1" :width="30" />
              <span>{{ transl.App.profile }}</span>
            </div>
            <div class="hamburger-item nav-settings" @click="$router.push({ name: 'UserSettings' })">
              <iconComponent symbol="gear" :width="30" />
              <span>{{ transl.App.settings }}</span>
            </div>
            <div class="hamburger-item nav-info" @click="$router.push({ name: 'HomeInfo' })">
              <iconComponent symbol="info" :width="30" />
              <span>{{ transl.App.about }}</span>
            </div>
            <div class="hamburger-item nav-support" @click="openSupportModal(transl.App.issueother, true)">
              <iconComponent symbol="headset" :width="30" />
              <span>{{ transl.App.support }}</span>
            </div>
            <a class="hamburger-item nav-faq" :href="faqUrl" target="_blank">
              <iconComponent symbol="chat" :width="30" />
              <span>{{ transl.App.faq }}</span>
            </a>
            <div class="a-line"></div>
            <div class="hamburger-item nav-logout" @click="logout()">
              <iconComponent symbol="openDoor" :width="30" />
              <span>{{ transl.App.logout }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="hamburger-header"
            :style="`background-image: url(${imgHeaderMobile});`">
            <img src="./assets/images/Enginio_logotype_horizontal_neg.png" alt="Enginio">
          </div>
          <div class="hamburger-list" @click="desktopMenuOpen = false; mobileMenuOpen = false">
            <div v-if="isDevelopment" class="hamburger-item nav-dev" @click="devLogin">
              <span>Dev login</span>
            </div>
            <div class="hamburger-item nav-signup" @click="setLoginView('signupView')">
              <img class="create-account-logo" src="./assets/images/DP_Icon_Blk.png" alt="Enginio">
              <span>{{ transl.App.register }}</span>
            </div>
            <div class="hamburger-item nav-login" @click="setLoginView('loginView')">
              <iconComponent symbol="person" :strokeWidth="0.1" :width="30" />
              <span>{{ transl.App.login }}</span>
            </div>
            <div class="hamburger-item nav-info" @click="$router.push({ name: 'HomeInfo' })">
              <iconComponent symbol="info" :width="30" />
              <span>{{ transl.App.about }}</span>
            </div>
            <div class="hamburger-item nav-support" @click="openSupportModal(transl.App.issueother, true)">
              <iconComponent symbol="headset" :width="30" />
              <span>{{ transl.App.support }}</span>
            </div>
            <a class="hamburger-item nav-faq" :href="faqUrl" target="_blank">
              <iconComponent symbol="chat" :width="30" />
              <span>{{ transl.App.faq }}</span>
            </a>
            <div class="a-line"></div>
          </div>
        </template>
        <div class="hamburger-footer">
          <div class="copyright">© | Enginio {{ currentYear }}</div>
          <div class="version">version {{ serverVersion }}</div>
          <div
            class="clickable nav-integrity"
            @click="gotoData()">
            {{ transl.HomeInfo.integrity }}
          </div>
        </div>
      </div>
    </transition>

    <div
      v-if="localCompany && localCompany.bulletin_message && !bulletinDismissed && isOnAnyBrandPage"
      class="bulletin-banner">
      <span v-html="localCompany.bulletin_message"></span>
      <button class="bulletin-banner__close" @click="bulletinDismissed = true" aria-label="Close">&times;</button>
    </div>

    <PartnerLayout
      v-if="loadedPage && partnerShell"
      :company="company"
      :company-id="localCompanyId"
      :hide-participations="!!localCompany.hide_participations_menu"
      :hide-receipts="!!localCompany.hide_receipts_menu"
      :user-name="`${user?.name ?? ''} ${user?.last_name ?? ''}`.trim()"
      :user-initials="userInitials"
      :show-restricted-items="isDevelopment || isFelicia"
      :server-version="serverVersion"
      @create-company="showCompanyWizard = true"
      @create-collection="showCollectionWizard = true"
      @switch-company="switchCompany()"
      @logout="logout()">
      <!-- Pages built on the new UI opt out of the legacy island with `meta.uiRoot`. -->
      <router-view :class="{ 'ui-legacy': !$route.meta.uiRoot }" v-bind="routerViewBindings" />
    </PartnerLayout>

    <!-- v-if="deviceId" v-if="loadedPage" -->
    <router-view
                 v-else-if="loadedPage"
                 class="router-view"
                 :class="{
                  'company-router': authenticated && companyType,
                  'admin-router': authenticated && adminType,
                  'game-wrapper': isOnGamePage,
                  'partner-fullscreen': onPartnerFullscreen,
                 }"
                 v-bind="routerViewBindings">
    </router-view>

    <modal v-if="((isOnBrandPage || isOnUserBrandPage) && loadedPageData || !isOnBrandPage && !isOnUserBrandPage) && loginModal"
           class="modal-view"
           @close="!mandatoryLogin ? setLoginView(false) : ()=>{}"
           :logo="loginModal && (!signupView && !changePhoneView && !loginView)"
           slotTransName="slot" slotTransMode="out-in" :slotTransAppear="true" size="medium">

      <slot>
        <div v-if="signupView" class="login-content --signup-container">

          <div class="--login-back">
            <div
                class="back-button--container"
                @click="setLoginView()">
              <iconComponent symbol="arrowLeft" :width="30" />
            </div>
            <div class="--signup-header-text">
              <h3>{{ transl.Login.signup1 }}</h3>
            </div>
            <div>
              <p v-if="phoneNrStep" class="--signup-step">1/3</p>
              <p v-if="codeStep" class="--signup-step">2/3</p>
              <p v-if="emailStep" class="--signup-step">3/3</p>
            </div>
          </div>

          <div class="--signup-content" v-if="phoneNrStep">
            <div class="--inputs-and-error">
              <div class="login-signup-body" v-html="localCompany?.signup_subheader || transl.Login.funtojoin.interpolate({ market: theMarket })"></div>
              <div class="--inputs-container">
                <InputField id="given-name" :label="`${transl.Login.firstname} *`" v-model="firstName" />
                <InputField id="family-name" :label="`${transl.Login.lastname} *`" v-model="lastName" />
                <InputField id="email" :label="`${transl.Login.emailadress} *`" v-model="emailadress" />
                <MazInputPhoneNumber id="tel" :block="true" :example="false"
                                    v-model="phoneNr"
                                    :country-code="countryCode"
                                    :only-countries="whitelistedCountryCodes"
                                    :validation-error="false"
                                    :validation-success="false"
                                    :translations="phoneInputTransl"
                                    orientation="row"
                                    @data="formattedNr = $event.formatInternational || ''"/>
                                    <!--v-on:keyup.enter="signupGetCode()"-->
                <div class="login-issue-text">
                  {{ loginPhoneIssue }}
                </div>
              </div>
            </div>

            <div v-if="!issueStep" class="--accept-terms">
              <div class="--confirm-terms">
                <inputField
                  v-model="acceptterms"
                  inputType="checkbox"/>

                <div class="--text">
                  <div class="clickable" @click="acceptterms = !acceptterms">
                    <span>* </span>
                    <span v-if="localCompany && localCompany._id">
                      {{ transl.Login.readconfirm2.interpolate({ companyname: localCompany.name }) }}
                    </span>
                    <span v-else>
                      {{ transl.Login.readconfirm }}
                    </span>
                  </div>
                  <div
                    class="clickable-link"
                    @click="accepttermsModal = !accepttermsModal">{{ transl.Login.userconditions }}</div>
                </div>
              </div>

              <div
                v-if="localCompany?._id"
                class="--newsletter">
                <inputField
                  v-model="companySubscribe"
                  inputType="checkbox"/>

                <div class="--text">
                  <div class="--expanded-text">
                    <div
                      v-if="localCompany.terms_description
                        && localCompany.terms_description.includes('<p>')"
                      class="--regular-expanded-text">
                      <div v-if="localCompany.terms_description.split('.').length >= 2
                        && localCompany.terms_description.split('.')[1].length > 20">
                        <div @click="companySubscribe = !companySubscribe" class="clickable">
                          <p>
                            <!--<span v-html="`<strong class='-read-confirm'>${localCompany.terms_description.split('<strong>')[0]}${localCompany.terms_mandatory ? '* ' : ''}${localCompany.terms_description.split('<strong>').slice(1).join('<strong>').split('.')[0]}.`"></span>-->
                            <span v-html="`${localCompany.terms_description.split('<p>')[0]}${localCompany.terms_mandatory ? '* ' : ''}${localCompany.terms_description.split('<p>').slice(1).join('<p>').split('.')[0]}.`"></span>
                          </p>
                        </div>
                        <div>
                          <div
                            v-show="collapsedNews[0]"
                            v-html="localCompany.terms_description.split('.').slice(1).join('.')"></div>
                          <div v-show="collapsedNews[0]" class="-show-more" @click="toggleShowMore(collapsedNews)">
                            {{ transl.UserSettings.showless }}
                            <iconComponent class="up" width="10" fill="#999999" stroke="#999999" symbol="forward" />
                          </div>
                          <div v-show="!collapsedNews[0]" class="-show-less" @click="toggleShowMore(collapsedNews)">
                            {{ transl.UserSettings.showmore }}
                            <iconComponent class="down" width="10" fill="#999999" stroke="#999999" symbol="forward" />
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-html="localCompany.terms_description"></div>
                      </div>
                    </div>
                    <div v-else>
                      <div @click="companySubscribe = !companySubscribe" class="clickable">
                        <p>
                          <span class="--regular-expanded-text">
                            <span v-if="localCompany.terms_mandatory">*</span>
                            {{ transl.Login.sendemails2.interpolate({ companyname: localCompany.name }) }}
                          </span>
                          <!--<span class="--regular-expanded-text">{{ transl.Login.sendemails2 }}</span>-->
                        </p>
                      </div>
                      <!--<div v-show="collapsedNews[0]" v-html="transl.Login.sendemails3"></div>-->
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="localCompany?.terms_2_description"
                class="--newsletter">
                <inputField
                  v-model="companySubscribe2"
                  inputType="checkbox"/>

                <div class="--text">
                  <div class="--expanded-text">
                    <div class="--regular-expanded-text">
                      <div v-if="localCompany.terms_2_description.split('.').length >= 2
                        && localCompany.terms_2_description.split('.')[1].length > 20">
                        <div @click="companySubscribe2 = !companySubscribe2" class="clickable">
                          <p>
                            <span v-html="`${localCompany.terms_2_description.split('<p>')[0]}${localCompany.terms_2_mandatory ? '* ' : ''}${localCompany.terms_2_description.split('<p>').slice(1).join('<p>').split('.')[0]}.`"></span>
                          </p>
                        </div>
                        <div>
                          <div
                            v-show="collapsedNews[0]"
                            v-html="localCompany.terms_2_description.split('.').slice(1).join('.')"></div>
                          <div v-show="collapsedNews[0]" class="-show-more" @click="toggleShowMore(collapsedNews)">
                            {{ transl.UserSettings.showless }}
                            <iconComponent class="up" width="10" fill="#999999" stroke="#999999" symbol="forward" />
                          </div>
                          <div v-show="!collapsedNews[0]" class="-show-less" @click="toggleShowMore(collapsedNews)">
                            {{ transl.UserSettings.showmore }}
                            <iconComponent class="down" width="10" fill="#999999" stroke="#999999" symbol="forward" />
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-html="localCompany.terms_2_description"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--<div v-if="localCompany && localCompany._id" class="--company-subscribe">
                <inputField
                  v-model="companySubscribe"
                  inputType="checkbox"/>

                <div class="--text">
                  <div class="--expanded-text" @click="companySubscribe = !companySubscribe">
                    <span class="-read-confirm">
                      <span v-if="localCompany.terms_mandatory">*</span>
                      {{ transl.Login.companynotification1.interpolate({ companyname: thirdPartyCrmName }) }}
                    </span>
                    <span> – {{ transl.Login.companynotification2.interpolate({ companyname: thirdPartyCrmName }) }}</span>
                  </div>
                  <a
                    v-if="localCompany.privacy_url"
                    class="clickable-link"
                    :href="localCompany.privacy_url"
                    target="_blank">{{ transl.Login.companynotification3 }}</a>
                </div>
              </div>-->

              <div class="mandatory-description">
                {{ transl.App.mandatory }}
              </div>

              <div class="login-issue-text">
                {{ loginIssue }}
              </div>
            </div>

            <div
              v-if="accepttermsModal"
              class="--terms">
              <div class="--terms-container">
                <div class="-header-container">
                  <h3>{{ transl.App.conditions }}</h3>
                  <iconComponent symbol="cross" @click="accepttermsModal = false" />
                </div>

                <div class="body-1" v-html="transl.HomeData.terms" @click="onSignupTermsClick">
                </div>
              </div>
              <div
                class="btn btn-activate button-user-modal"
                @click="acceptterms = true; accepttermsModal = false;">
                {{ transl.Login.confirm }}
              </div>
            </div>

            <div class="--buttons-container">
              <div
                v-if="issueStep && (isOnAnyBrandPage)"
                class="login-signup-body --tech-issues">
                {{ transl.Login.techissues }}
                <div
                  class="clickable-link"
                  @click="openSupportModal(transl.App.issuesignup)">{{ transl.Login.contactsupport }}</div>
              </div>

              <altcha-widget
                ref="altchaWidget"
                :challenge="captchaChallengeUrl"
                display="invisible"
                auto="onload"
                :hideFooter="true"
                :hideLogo="true"
                @verified="onAltchaVerified"></altcha-widget>

              <div v-if="!accepttermsModal"
                class="btn btn-activate --continue-btn"
                :style="`background: ${disabledNewUser ? `color-mix(in srgb, var(--brand-button-color) 50%, transparent) !important` : '' }`"
                @click="signupGetCode()">
                {{ transl.Login.continue }}
              </div>

              <div v-if="issueStep" class="--or-btns">
                <div class="login-issue-or-text">
                  {{ transl.Login.or }}
                </div>
                <div>
                  <div
                    class="btn btn-transparent"
                    @click="setLoginView('changePhoneView')">
                    {{ transl.Login.changednrq }}
                  </div>
                  <div
                    class="btn btn-transparent"
                    @click="setLoginView('loginView')">
                    {{ transl.Login.login }}
                  </div>
                </div>
              </div>
            </div>

            <integrityBox v-if="!accepttermsModal" @click="gotoData()"
                          badgeType="Integrity_badge_Medium" :textData="[transl.Login.whenmember, transl.Login.integritypolicyinfo]"/>
          </div>

          <div v-else-if="codeStep" class="--verify-email-phone">
            <div class="login-signup-body">{{ transl.Login.verifyboth }}</div>
            <div class="login-verification-step">
              <div class="back-button--container"
                :style="`background-color: ${ validationCodePhone && validationCodePhone.length ? '#4ECB71' : ''}`">
                <iconComponent
                  v-if="validationCodePhone && validationCodePhone.length"
                  symbol="checkmark"
                  stroke="white" fill="white"/>
                <iconComponent
                  v-else
                  symbol="smartphone"
                  stroke="black" fill="black"
                  width="30px" height="30px"/>
              </div>
              <div>{{ transl.Login.usethencode }}</div>
              <aPinInput
                key="phone-code"
                :auto-focus="true"
                @incomplete="setValidationCode()"
                @complete="setValidationCode($event)"/>

              <div class="login-issue-text">
                {{ loginCodeIssue }}
              </div>
            </div>

            <div class="login-signup-body">{{ transl.Login.nocode }}
              <span
                    class="clickable-link"
                    @click="sendAnotherPhoneCode()">{{ transl.Login.sendnew }}</span>
            </div>

            <div class="login-issue-text">
              {{ loginIssue }}
            </div>

            <div
                :class="{ 'btn-disabled': incompleteValidationCode }"
                class="btn btn-activate"
                @click="signupVerifyPhoneNr()">
              {{ transl.Login.goon }}
            </div>
          </div>

          <div v-else-if="emailStep" class="--verify-email-phone">
            <div class="login-signup-body">{{ transl.Login.verifyboth }}</div>
            <div class="login-verification-step">
              <div class="back-button--container"
                :style="`background-color: ${ validationCodeEmail && validationCodeEmail.length ? '#4ECB71' : ''}`">
                <iconComponent
                  v-if="validationCodeEmail && validationCodeEmail.length"
                  symbol="checkmark"
                  stroke="white" fill="white"/>
                <iconComponent
                  v-else
                  symbol="email"
                  stroke="black" fill="black"/>
              </div>
              <div>{{ transl.Login.usethenemailcode }}</div>
              <aPinInput
                key="email-code"
                :auto-focus="true"
                :inputs="4"
                @incomplete="setValidationCode()"
                @complete="setValidationCode($event)"/>

              <div class="login-issue-text">
                {{ loginEmailIssue }}
              </div>
            </div>

            <div class="login-signup-body">{{ transl.Login.nocode }}
              <span
                    class="clickable-link"
                    @click="sendAnotherEmailCode()">{{ transl.Login.sendnew }}</span>
            </div>

            <div class="login-issue-text">
              {{ loginIssue }}
            </div>

            <div
                :class="{ 'btn-disabled': incompleteValidationCode }"
                class="btn btn-activate"
                @click="signupVerifyPhoneNr()">
              {{ transl.Login.goon }}
            </div>
          </div>
        </div>

        <div v-else-if="loginView" class="login-content --login-container">
          <div class="--login-back">
            <div
                class="back-button--container"
                @click="setLoginView()">
              <iconComponent symbol="arrowLeft" :width="30" />
            </div>
            <h3>{{ transl.Login.login }}!</h3>
            <Hero
                  class="login-absolute-stamp"
                  type="Integrity_badge_Light" />
          </div>

          <div class="--content" v-if="phoneNrStep">
            <div class="body-1">
              {{ transl.Login.addphonenr }}
            </div>

            <div class="--input-container">
              <MazInputPhoneNumber id="tel" :block="true" :example="false"
                                  v-model="phoneNr"
                                  :country-code="countryCode"
                                  :only-countries="whitelistedCountryCodes"
                                  :validation-error="false"
                                  :validation-success="false"
                                  :translations="phoneInputTransl"
                                  orientation="row"
                                  @data="formattedNr = $event.formatInternational || ''"/>
              <div v-if="loginPhoneIssue" class="login-issue-text">{{ loginPhoneIssue }}</div>
              <div v-if="loginIssue" class="login-issue-text">{{ loginIssue }}</div>
            </div>

            <div class="--buttons-container">
              <div
                  v-if="issueStep && (isOnAnyBrandPage)"
                  class="login-signup-body --tech-issues">
                {{ transl.Login.techissues }}
                <div
                    class="clickable-link"
                    @click="openSupportModal(transl.App.issuelogin)">{{ transl.Login.contactsupport }}</div>
              </div>

              <altcha-widget
                  ref="altchaWidget"
                  :challenge="captchaChallengeUrl"
                  display="invisible"
                  auto="onload"
                  :hideFooter="true"
                  :hideLogo="true"
                  @verified="onAltchaVerified"></altcha-widget>

              <div class="--continue-btn">
                <div class="login-description">
                  {{ transl.Login.usecode }}
                </div>
                <div
                    class="btn btn-activate"
                    @click="loginGetCode()">
                  {{ transl.Login.continue }}
                </div>
              </div>

              <div v-if="issueStep" class="--or-btns">
                <div class="login-issue-or-text">
                  {{ transl.Login.or }}
                </div>
                <div>
                  <div
                      class="btn btn-transparent"
                      @click="setLoginView('changePhoneView')">
                    {{ transl.Login.changednrq }}
                  </div>
                  <div
                      class="btn btn-transparent"
                      @click="setLoginView('signupView')">
                    {{ transl.Login.signup2 }}
                  </div>
                </div>
              </div>
            </div>

            <integrityBox badgeType="Integrity_badge_Medium" @click="gotoData()"
              :textData="[transl.Login.yourintegrity, transl.Login.nrgpolicy, transl.Login.contactpolicy]"/>
          </div>

          <div v-else-if="codeStep" class="--verify-and-login">
            <iconComponent symbol="confetti" stroke="#EA7801" fill="#EA7801" :width="65" />
            <div class="subtitle-small">{{ transl.Login.verifylogin }}</div>
            <div class="login-verification-step">
              <div>{{ transl.Login.usethencode }}</div>
              <aPinInput
                key="phone-code"
                :auto-focus="true"
                @incomplete="setValidationCode()"
                @complete="setValidationCode($event)"/>

              <div class="login-issue-text">
                {{ loginCodeIssue }}
              </div>
            </div>

            <div class="login-signup-body">{{ transl.Login.nocode }}
              <span
                    class="clickable-link"
                    @click="sendAnotherPhoneCode()">{{ transl.Login.sendnew }}</span>
            </div>

            <div class="login-issue-text">
              {{ loginIssue }}
            </div>

            <div
                class="btn btn-activate"
                @click="loginVerifyPhoneNr()">
              {{ transl.Login.complete }}
            </div>
          </div>
        </div>

        <div v-else-if="changePhoneView" class="login-content --new-number-container">
          <div class="--login-back">
            <div
              class="back-button--container"
              @click="setLoginView()">
              <iconComponent symbol="arrowLeft" :width="30" />
            </div>
            <h3>{{ transl.Login.changenr }}</h3>
            <Hero
              class="login-absolute-stamp"
              type="Integrity_badge_Light"/>
          </div>

          <div class="--content" v-if="phoneNrStep">
            <div class="body-2">{{ transl.Login.updatenrinfo }}</div>

            <div class="--choose-verify">
              <div class="small-text">{{ transl.Login.verifyyourself }}</div>
              <div class="--input-container">
                <InputField inputType="toggle" :label="transl.Login.emailadress"
                            @inputClick="verifyByEmail = !verifyByEmail" :modelValue="verifyByEmail" />
                <InputField inputType="toggle" :label="transl.Login.telnr"
                            @inputClick="verifyByEmail = !verifyByEmail" :modelValue="!verifyByEmail" />
              </div>
            </div>

            <div v-if="!verifyByEmail" class="--verify-number">
              <div class="--old-num">
                <div class="small-text">{{ transl.Login.oldnr }}</div>
                <MazInputPhoneNumber id="tel" :block="true" :example="false" v-model="oldPhoneNr"
                                    :country-code="countryCode"
                                    :only-countries="whitelistedCountryCodes"
                                    :validation-error="false"
                                    :validation-success="false"
                                    :translations="phoneInputTransl"
                                    orientation="row"
                                    @data="oldFormattedNr = $event.formatInternational || ''"/>
                <div class="login-issue-text">
                  {{ loginPhoneIssue }}
                </div>
              </div>

              <div class="--new-num">
                <div class="small-text">{{ transl.Login.newphonenr }}</div>
                <MazInputPhoneNumber id="tel" :block="true" :example="false" v-model="phoneNr"
                                    :country-code="countryCode"
                                    :only-countries="whitelistedCountryCodes"
                                    :validation-error="false"
                                    :validation-success="false"
                                    :translations="phoneInputTransl"
                                    orientation="row"
                                    @data="formattedNr = $event.formatInternational || ''"/>
                <div class="login-issue-text">
                  {{ loginNewPhoneIssue }}
                </div>
              </div>
            </div>

            <div v-if="verifyByEmail" class="--verify-email">
              <div class="--fill-email">
                <div class="small-text">{{ transl.Login.oldemail }}</div>
                <InputField id="email" :label="transl.Login.emailadress" v-model="emailadress" />
                <div class="login-issue-text">
                  {{ loginEmailIssue }}
                </div>
              </div>

              <div class="--new-num">
                <div class="small-text">{{ transl.Login.newphonenr }}</div>
                <MazInputPhoneNumber id="tel" :block="true" :example="false" v-model="phoneNr"
                                    :country-code="countryCode"
                                    :only-countries="whitelistedCountryCodes"
                                    :validation-error="false"
                                    :validation-success="false"
                                    :translations="phoneInputTransl"
                                    orientation="row"
                                    @data="formattedNr = $event.formatInternational || ''"/>
                <div class="login-issue-text">
                  {{ loginNewPhoneIssue }}
                </div>
              </div>
            </div>

            <div class="--buttons-container">
              <div
                v-if="issueStep && (isOnAnyBrandPage)"
                class="login-signup-body --tech-issues">
                {{ transl.Login.phoneemailissue }}
                <div
                  class="clickable-link"
                  @click="openSupportModal(transl.App.issuechangephone)">{{ transl.Login.contactsupport }}
                </div>
              </div>

              <altcha-widget
                ref="altchaWidget"
                :challenge="captchaChallengeUrl"
                display="invisible"
                auto="onload"
                :hideFooter="true"
                :hideLogo="true"
                @verified="onAltchaVerified"></altcha-widget>

              <div
                class="btn btn-activate --continue-btn"
                @click="changePhoneNr()">
                {{ transl.Login.continue }}
              </div>

              <div v-if="issueStep" class="--or-btns">
                <div class="login-issue-or-text">
                  {{ transl.Login.or }}
                </div>

                <div>
                  <div
                    class="btn btn-transparent"
                    @click="setLoginView('signupView')">
                    {{ transl.Login.signup2 }}
                  </div>

                  <div
                    class="btn btn-transparent"
                    @click="setLoginView('loginView')">
                    {{ transl.Login.login }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="codeStep" class="--verify-new-number">
            <div class="login-signup-body">{{ transl.Login.verifyboth }}</div>
            <div class="login-verification-step">
              <div class="back-button--container"
                :style="`background-color: ${ validationCodePhone && validationCodePhone.length ? '#4ECB71' : ''}`">
                <iconComponent
                  v-if="validationCodePhone && validationCodePhone.length"
                  symbol="checkmark"
                  stroke="white" fill="white"/>
                <iconComponent
                  v-else
                  symbol="smartphone"
                  stroke="black" fill="black"
                  width="30px" height="30px"/>
              </div>
              <div>{{ transl.Login.verifyboth }}</div>
              <aPinInput
                key="phone-code"
                :auto-focus="true"
                @incomplete="setValidationCode()"
                @complete="setValidationCode($event)"/>

              <div class="login-issue-text">
                {{ loginCodeIssue }}
              </div>
            </div>

            <div class="login-signup-body">{{ transl.Login.nocode }}
              <span
                class="clickable-link"
                @click="sendAnotherPhoneCode()">{{ transl.Login.sendnew }}</span>
            </div>

            <div class="login-issue-text">
              {{ loginIssue }}
            </div>

            <div
              :disabled="!verifyByEmail || !validationCodePhone || !validationCodePhone.length"
              class="btn btn-activate"
              :class="{ 'btn-disabled': !verifyByEmail || !validationCodePhone || !validationCodePhone.length }"
              @click="signupVerifyPhoneNr()">
              {{ transl.Login.complete }}
            </div>
          </div>

          <div v-else-if="emailStep" class="--verify-email-phone">
            <div class="login-signup-body">{{ transl.Login.verifyboth }}</div>
            <div class="login-verification-step">
              <div class="back-button--container"
                :style="`background-color: ${ validationCodeEmail && validationCodeEmail.length ? '#4ECB71' : ''}`">
                <iconComponent
                  v-if="validationCodeEmail && validationCodeEmail.length"
                  symbol="checkmark"
                  stroke="white" fill="white"/>
                <iconComponent
                  v-else
                  symbol="email"
                  stroke="black" fill="black"/>
              </div>
              <div>{{ transl.Login.usethenemailcode }}</div>
              <aPinInput
                key="email-code"
                :auto-focus="true"
                :inputs="4"
                @incomplete="setValidationCode()"
                @complete="setValidationCode($event)"/>

              <div class="login-issue-text">
                {{ loginEmailIssue }}
              </div>
            </div>

            <div class="login-signup-body">{{ transl.Login.nocode }}
              <span
                    class="clickable-link"
                    @click="sendAnotherEmailCode()">{{ transl.Login.sendnew }}</span>
            </div>

            <div class="login-issue-text">
              {{ loginIssue }}
            </div>

            <div
                :class="{ 'btn-disabled': incompleteValidationCode }"
                class="btn btn-activate"
                @click="signupVerifyEmail()">
              {{ transl.Login.goon }}
            </div>
          </div>
        </div>

        <div v-else class="login-content --login-menu-container">
          <div
            v-if="localCompany"
            class="login-header --logo-container">
            <img
                v-if="localCompany.icon_1x1?.url || localCompany.icon?.url"
                class="login-header-logo"
                :src="localCompany.icon_1x1?.url || localCompany.icon?.url"
                :alt="localCompany.name" />
            <h3 class="modal-view-header-text">
              {{ transl.Login.loginfirst }}
            </h3>
            <div
              class="modal-view-subheader-text"
              v-html="localCompany?.login_landing_subheader || transl.Login.companywhy2.interpolate({ companyname: localCompany.name })">
            </div>
          </div>
          <div class="login-header" v-else>
            <img
                class="login-header-logo"
                src="./assets/images/DP_Icon_Blk.png"
                alt="Enginio">
            <h3 class="modal-view-header-text">
              {{ transl.Login.funtohaveyou }}
            </h3>
            <div class="modal-view-subheader-text">
              {{ transl.Login.companywhy }}
            </div>
          </div>
          <div
              class="btn btn-activate"
              @click="setLoginView('signupView')">
            {{ transl.Login.signup }}
          </div>
          <div
              v-if="localCompany && localCompany.login_design == 'TEXT_BUTTONS'"
              class="btn btn-icon-text"
              style="font-size: 15px; margin: 10px 0 0 0"
              @click="setLoginView('loginView')">
            {{ transl.Login.logintext }}
          </div>
          <div
              v-else
              class="btn btn-transparent"
              @click="setLoginView('loginView')">
            {{ transl.Login.login }}
          </div>
          <div
              class="btn btn-icon-text"
              style="font-size: 15px; margin: 10px 0 0 0"
              @click="setLoginView('changePhoneView')">
            {{ transl.Login.changednr }}
          </div>
          <hr>
          <div
              class="btn btn-gray-no-border"
              @click="gotoInfo()">
            {{ transl.Login.what }}
          </div>

          <integrityBox badgeType="Integrity_badge_Medium"
                        :textData="transl.HomeInfo.safeintegrity + ' ' + transl.HomeInfo.readcare"
                        :linksList="[transl.HomeInfo.integrity, 'FAQ']"
                        @linkClick0="gotoData()"
                        @linkClick1="openUrl(faqUrl)"/>
        </div>
      </slot>
    </modal>

    <div
         v-if="newUserModal"
         class="--new-user-modal">
      <div class="new-user-content-modal">

        <div class="--helper">
          <p class="subtitle-small">{{ transl.Login.profileshow }}</p>
        </div>

        <div class="--welcome">
          <h3 style="padding-bottom: 1rem; text-align: center;">
            {{ transl.Login.welcomeheader }}
          </h3>

          <div style="font-size: 16px; text-align: center; padding-bottom: 2rem;">
            {{ transl.Login.oneplace }}
          </div>

          <div
               v-if="localCompany && !isHomePage"
               class="new-user-company-image"
               :style="`background-image: url(${localCompany.media ? localCompany.media.url : ''});`">
            <img
                 v-if="localCompany.icon_1x1?.url || localCompany.icon?.url"
                 class="new-user-company-icon"
                 :src="localCompany.icon_1x1?.url || localCompany.icon?.url" />
          </div>

          <div
               v-else
               class="new-user-homepage-image">
            <img
                 class="new-user-homepage-icon"
                 src="../src/assets/images/Enginio_logotype_stacked_neg.png" />
          </div>

          <button
            class="btn btn-activate"
            @click="newUserModal = false">
            {{ transl.Login.ok }}
          </button>
        </div>
      </div>
    </div>


    <modal v-if="supportModal" class="modal-view --support-modal" @close="supportModal = false;"
            :header="{closeButton: true, text: transl.App.supportcase}" size="medium">
      <slot>
        <div class="support-content-modal">

          <div>{{ transl.App.inenglishplz }}</div>

          <div class="input-container">
            <InputField inputType="select" :label="transl.App.subject" :selectOptions="supportSubjectOptions"
                        v-model="supportSubject" />
            <InputField id="given-name" :required="true" :helperText="transl.App.mandatory"
                        :label="transl.Login.firstname"
                        v-model="supportName" validationType="textOnly" />
            <InputField id="family-name" :label="transl.Login.lastname" v-model="supportLastName" />

            <div
                class="vuephoneinput-container"
                v-if="supportSubject === transl.App.issueactivation || supportSubject === transl.App.issuechangephone">
              <div class="small-text-bold">{{ transl.App.inputoldnr }}</div>

              <MazInputPhoneNumber id="tel" :block="true" :example="false" v-model="supportOldPhoneNr"
                                  :required="true"
                                  :country-code="countryCode"
                                  :only-countries="whitelistedCountryCodes"
                                  :translations="phoneInputTransl"
                                  orientation="row"
                                  @data="formattedSupportOldPhoneNr = $event.formatInternational || ''"/>
            </div>

            <div class="vuephoneinput-container">
              <div class="small-text-bold" v-if="supportSubject === transl.App.issueactivation">
                {{ transl.App.inputthisnr }}
              </div>

              <div class="small-text-bold" v-else-if="supportSubject === transl.App.issuechangephone">
                {{ transl.App.inputnewnr }}
              </div>

              <MazInputPhoneNumber id="tel" :block="true" :example="false" v-model="supportPhoneNr"
                                  :required="true"
                                  :country-code="countryCode"
                                  :only-countries="whitelistedCountryCodes"
                                  :translations="phoneInputTransl"
                                  orientation="row"
                                  @data="formattedSupportPhoneNr = $event.formatInternational || ''"/>
            </div>

            <InputField id="email" inputType="email" :required="true" :helperText="transl.App.mandatory"
                        :label="transl.Login.emailadress"
                        v-model="supportEmail" :placeholder="'example@example.com'" />

            <p class="small-text-bold"
              v-if="supportSubject === transl.App.issueother || supportSubject === transl.App.issuedelivery">
              {{ transl.App.whatquestion }}
            </p>

            <p class="small-text-bold" v-else>{{ transl.App.whatproblem }}</p>

            <InputField inputType="textarea" id="description" label="" :placeholder="transl.App.description"
                        v-model="supportDescription" />
          </div>

          <button
            class="btn btn-activate"
            :class="{ 'btn-disabled': (supportName === '' || supportLastName === '' || supportPhoneNr === '' || supportDescription === '')}"
            @click="sendSupportCase()">
            {{ transl.App.sendcase }}
          </button>
        </div>
      </slot>
    </modal>

    <modal v-if="loadedPageData && subscribeModal" class="modal-view --subscribe-modal"
           @close="subscribeModal = false;" size="medium">
      <slot>
        <div class="subscribe-content-modal">
          <div
              class="close-login-modal-button"
              @click="subscribeModal = false">
            <iconComponent symbol="cross" />
          </div>

          <div class="subscribe-content" v-if="!authenticated">
            <img
                v-if="localCompany && (localCompany.icon_1x1?.url || localCompany.icon?.url)"
                class="company-icon"
                :src="localCompany.icon_1x1?.url || localCompany.icon?.url"
                :alt="localCompany.name" />
            <div class="subscribe-header">{{ transl.Newsletter.loginfornews }}</div>
            <div class="subscribe-body">{{ transl.Newsletter.ifnoaccount }}</div>
            <div
                class="btn btn-activate"
                @click="subscribeModal = false; setLoginView('loginView')">
              {{ transl.Newsletter.login }}
            </div>
            <div
                class="btn btn-transparent"
                @click="subscribeModal = false; setLoginView('signupView')">
              {{ transl.Newsletter.signup }}
            </div>
          </div>

          <div class="subscribe-content" v-else-if="user && !user.verified_email">
            <iconComponent class="icon-component" symbol="emailWithPlus" width="50" stroke="#EA7801"
                          fill="#EA7801" />
            <div class="subscribe-header">{{ transl.Newsletter.verifyemail }}</div>
            <div class="subscribe-body">{{ transl.Newsletter.verifyemailbody }}</div>
            <div
                class="btn btn-activate"
                @click="subscribeModal = false; verifyEmail({ subscribe: true })">
              {{ transl.Newsletter.verifybtn }}
            </div>
          </div>

          <div
            class="subscribe-content"
            v-else-if="user && user.verified_email && !hasSubscribed">
            <img
              v-if="company.icon_1x1?.url || company.icon?.url"
              class="company-header-logo"
              :src="company.icon_1x1?.url || company.icon?.url" />
            <div v-if="localCompany && localCompany._id" class="--accept-terms">
              <div class="--company-subscribe" style="margin: 0; max-width: 100%;">
                <inputField
                  v-model="companySubscribe"
                  inputType="checkbox"/>
                <div
                  v-if="localCompany.terms_description"
                  v-html="localCompany.terms_description"
                  class="--company-subscribe-description"></div>

                <inputField
                  v-if="localCompany.terms_2_description"
                  v-model="companySubscribe2"
                  inputType="checkbox"/>
                <div
                  v-if="localCompany.terms_2_description"
                  v-html="localCompany.terms_2_description"
                  class="--company-subscribe-description"></div>

                <div class="--text">
                  <a
                    v-if="localCompany.privacy_url"
                    class="clickable-link"
                    :href="localCompany.privacy_url"
                    target="_blank">{{ transl.Login.companynotification3 }}</a>
                </div>
              </div>

              <div
                class="btn btn-activate"
                :class="{ 'btn-disabled': disabledCompanySubscribe }"
                @click="subscribeCompany()">
                {{ localCompany.subscribe_button_text || transl.Newsletter.prenumbtn }}
              </div>
              <div
                class="btn btn-secondary"
                @click="subscribeModal = false">
                {{ transl.Newsletter.later }}
              </div>
            </div>
            <div v-else>
              <div class="subscribe-header">{{ transl.Newsletter.prenumheader }}</div>
              <div class="subscribe-body">{{ transl.Newsletter.prenumbody }}</div>
              <div
                class="btn btn-activate"
                @click="subscribeCompany()">
                {{ transl.Newsletter.prenumbtn }}
              </div>
              <div
                class="btn btn-secondary"
                @click="subscribeModal = false">
                {{ transl.Newsletter.later }}
              </div>
            </div>
          </div>

          <div class="subscribe-content"
              v-else-if="user && user.verified_email && hasSubscribed">
            <iconComponent class="icon-component" symbol="easy" width="50" stroke="#EA7801" fill="#EA7801" />
            <div class="subscribe-header">{{ transl.Newsletter.alreadyheader }}</div>
            <div class="subscribe-body">{{ transl.Newsletter.alreadybody }}</div>
            <div
              class="btn btn-activate"
              @click="subscribeModal = false">
              {{ transl.Newsletter.noplz }}
            </div>
            <div
              class="btn btn-secondary"
              @click="subscribeCompany(true)">
              {{ transl.Newsletter.yeplz }}
            </div>
          </div>
        </div>
      </slot>
    </modal>

    <modal v-if="loadedPageData && faqModal && faqSubjects && faqSubjects.length"
           class="modal-view --faq-modal"
           :header="{ text: faqTitle, closeButton: true }"
           @close="faqModal = false;" size="medium">
      <slot>
        <FAQ
          :subjects="faqSubjects"
          :questions="faqQuestions"
          :disableSubject="faqDisableSubject" />
      </slot>
    </modal>

    <modal v-if="adblockModal"
           :header="{text: 'Adblock detected!', textPosition: 'center', bgColor: '#F2F2F2'}"
           class="modal-view --adblock-modal"
           size="medium">
      <slot>
        <div class="adblock-content-modal">
          <iconComponent symbol="stop" :width="60"/>
          <h3>It looks like you're using an Adblock!</h3>
          <div>Please disable your Adblocker and Refresh the page to view the content</div>
        </div>
      </slot>
    </modal>

    <modal v-if="loadedPageData && companyLockedModal"
        class="modal-view --company-locked-modal"
        size="medium">
      <slot>
        <div
          v-html="localCompany.lock_explanation || 'The brand is locked'"
          style="margin: 18px 0 10px 0;"></div>
        <button class="btn btn-activate" v-if="localCompany.lock_button_text" @click="openUrl(localCompany.lock_button_url)">
          {{ localCompany.lock_button_text }}
        </button>
      </slot>
    </modal>

    <transition name="fade" appear>
      <div v-if="cookieModal" class="cookie-modal-background"></div>
    </transition>
    <transition name="slide" appear>
      <div
           v-if="cookieModal"
           class="cookie-modal">
        <div class="cookie-modal-content">
          <div class="cookie-modal-text">
            <div class="cookie-header">
              <i class="cookie-modal-icon fas fa-cookie-bite fa-2x"></i>
              <h3>A greater experience of Enginio</h3>
            </div>
            <!--<a :href="`${windowOrigin}/companies`">company you interact with</a>-->
            <div>We at Enginio AB and the company you
              interact with on Enginio want to <b>give you the best possible experience and make
                improvements</b> to Enginio by using cookies from <a href="https://www.google.com/analytics/"
                 target="_blank">Google Analytics</a> and by analysing your
              personal data. We also use cookies and your personal data to provide you with <b>relevant
                marketing</b> when you visit other sites as Facebook.</div>
            <div style="margin: 10px 0;">Don’t worry, we do not look at individual visitors to Enginio but
              want to understand how devices find and use Enginio. We have as far as possible anonymised the
              information that we collect about you, e.g. by using an encrypted version of your IP address.
            </div>
            <div class="cookie-modal-confirm-toggle show-desktop">
              <InputField inputType="toggle" label="Allow Google and Facebook to collect user behaviour" id="asd123"
                          @inputClick="disableGTM = !disableGTM" :modelValue="!disableGTM" />
            </div>
          </div>
          <div class="cookie-modal-confirm">
            <div
                 class="btn btn-activate"
                 @click="acceptCookieModal()">
              OK, I understand
            </div>
            <div style="max-width: 400px; margin: 5px auto;">
              <a :href="`${windowOrigin}/data`">Here</a> you can read more about your rights and find
              information about how we use cookies and how we process your personal data.
            </div>
            <div class="cookie-modal-confirm-toggle show-mobile-and-tablet">
              <InputField inputType="toggle" label="Allow Google and Facebook to collect user behaviour" id="qwe123"
                          @inputClick="disableGTM = !disableGTM" :modelValue="!disableGTM" />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="bounce">
      <!-- The partner shell shows these through PartnerAlerts instead. -->
      <div
        v-if="showSnackbar && !partnerShell"
        class="snackbar"
        :style="`top: ${snackbarTop}; bottom: ${snackbarBot}; left: ${snackbarLeft}; right: ${snackbarRight}; background-color: ${snackbarBackground}`">
        <div class="snackbar-message">{{ messageSnackbar }}</div>
        <div
          v-if="closeSnackbar"
          class="snackbar-close-btn"
          @click="showSnackbar = false">
          <iconComponent symbol="cross" fill="white" stroke="white"/>
        </div>
      </div>
    </transition>

    <div id="control-height"></div>

    <div id="modals"></div>

    <CompanyWizard
      :show="showCompanyWizard"
      @close="showCompanyWizard = false"
    />

    <CampaignWizard
      :data="collectionWizard"
      :show="showCollectionWizard"
      @close="showCollectionWizard = false"
      @changeData="setCollectionWizardData"
      @createCampaign="createNewCampaign"
      @disappeared="resetCollectionWizardData"
    />

  </div>
</template>


<script>
import { defineAsyncComponent } from 'vue';
import axios from 'axios';
// import userApi from './api/user.api';
import { cloneDeep as _cloneDeep } from 'lodash-es';
import { mapGetters, mapMutations } from 'vuex';
import { isMobile, osName, browserName, mobileModel } from 'mobile-device-detect';
// import CodeInput from "vue-verification-code-input";
import EventBus from './resources/eventBus';
import aPinInput from './components/APinInput';
import Hero from './stories/components/Hero/Hero.vue';
import InputField from './stories/components/InputField/InputField.vue';
import IntegrityBox from './stories/components/IntegrityBox/IntegrityBox.vue';
import FAQ from './stories/components/FAQ/FAQ.vue'
import EntityMixin from './mixins/EntityMixin.vue';
import CompanyWizard from "@/stories/components/CompanyWizard/CompanyWizard.vue";
import CampaignWizard from "@/stories/components/CampaignWizard/CampaignWizard.vue";
import PartnerMixin from "@/mixins/PartnerMixin.vue";
import imgHeaderMobile from './assets/images/enginio_header_mobile.png';

export default {
  name: 'App',
  components: {
    CampaignWizard,
    CompanyWizard,
    // Loaded on demand so consumer pages don't download the shadcn-vue/Tailwind layer.
    PartnerLayout: defineAsyncComponent(() => import('@/layouts/PartnerLayout.vue')),
    Hero,
    IntegrityBox,
    aPinInput,
    InputField,
    FAQ,
  },
  mixins: [EntityMixin, PartnerMixin],
  mounted() {
    /*this.loginModal = true;
    this.signupView = true;
    this.phoneNrStep = false;
    this.codeStep = false;
    this.emailStep = true;*/

    // Brute redirect
    // TODO: is it needed, what are alternatives?
    // if (!this.isDevelopment &&
    //   !this.currentUrl.includes('enginio.io') && (this.isMarketPicker || this.isHomePage)) {
    //   location.assign(`https://www.enginio.io${this.theMarket ? `/${this.theMarket}` : ''}`);
    // }

    this.disableGTM = localStorage.getItem('disableGTM') == 'true' ? true : false;

    /*const referral = document.referrer || process.env.HTTP_REFERER;
    if (referral && !referral.includes('goodiebag')) {
      this.$dpAnalytics({ view: 'App', subject: 'digital referral', action: referral });
      // alert('referral: ' + referral);
      // this.$dpAnalytics({ view: 'app', subject: 'referral', action: referral });
    }
    this.$dpAnalytics({ view: 'App', action: 'enter' });*/
    this.pushDataLayer({
      parentCompany: 'None',
      company: 'None',
      goodiebag: 'None',
      offer: 'None',
      action: 'Enter Enginio',
    });

    this.openCookieModal();

    const {
      error = false,
      login = false,
      support = false,
      subscribe = false,
      // signupView = false, loginView = false,
    } = this.$route.query;

    /*if (utm_source || so || utm_medium || me) {
      setTimeout(() => {
        this.$dpAnalytics({
          view: this.currentUrl,
          subject: `${so || utm_source} source`,
          action: `${me || utm_medium} referral`,
        });
      }, 2000);
    }*/

    if (error) {
      this.setAlert({ message: error, seconds: 6, close: 'OK' });
    }

    /*if (signupView || loginView) {
      this.signupView = (signupView == 'true');
      this.loginView = (loginView == 'true');
      this.loginModal = true;
    // } else {
    //  this.loginModal = false;
    }*/

    console.log('[App mounted]', 'Setting version to:', window.enginio_env?.ENGINIO_VERSION);
    this.serverVersion = window.enginio_env?.ENGINIO_VERSION ?? 'local';
    console.log('[App mounted]', 'Setting language to:', window.enginio_env?.ENGINIO_LANG);
    // this.setLanguage(window.enginio_env?.ENGINIO_LANG ?? 'EN');
    this.validateUser();

    this.deviceType = this.mobileModel !== 'none' ? this.mobileModel : this.osName;
    this.browserType = this.browserName.replace('Mobile ', '');

    EventBus.on('authChange', () => {
      this.validateUser();
    });

    EventBus.on('logout', () => {
      this.logout();
    });

    EventBus.on('feLogout', () => {
      this.feLogout();
    });

    EventBus.on('setAlert', (data) => {
      this.setAlert(data);
    });

    EventBus.on('CHANGED_TRANSL', () => {
      this.phoneInputTransl = {
        countrySelect: {
          placeholder: this.transl.App.phoneinputcoutry,
        },
        phoneInput: {
          placeholder: `${this.transl.App.phoneinputnr} *`,
          example: this.transl.App.phoneinputexample,
        },
      };
      this.supportSubjectOptions = [
        this.transl.App.issueother,
        this.transl.App.issuedelivery,
        this.transl.App.issuetech,
        this.transl.App.issueactivation,
        this.transl.App.issueemail,
        this.transl.App.issuechangephone,
        this.transl.App.issuelogin,
        this.transl.App.issuesignup
      ];
    });

    if (login === true || login === 'true') {
      this.setLoginView();
    }
    if (support === true || support === 'true') {
      this.supportModal = true;
    }
    if ((subscribe === true || subscribe === 'true') && (this.isOnBrandPage || this.isOnUserBrandPage)) {
      console.log('[App - mounted]', 'subscribe', 'show subscribe modal');
      this.subscribeModal = true;
    }

    this.bootIntercomWidget();
    this.setBlackBox();

    document.body.style.setProperty('--nav-height', this.cssProps['--nav-height']);
  },
  /*
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.scrollTo(0, 0);
    });
  },
  */
  computed: {
    ...mapGetters('search', {
      searchGoodiebags: 'goodiebags',
      searchOffers: 'offers',
    }),
    ...mapGetters([
      'user', 'userStatus',
      'loadedPageData'
    ]),
    captchaChallengeUrl() {
      return `${axios.defaults.baseURL}/api/nar/captcha/challenge`;
    },
    adminType() {
      return this.userType === 'admin';
    },
    companyType() {
      return this.userType === 'company';
    },
    consumerType() {
      return this.userType === 'consumer';
    },
    isFelicia() {
      return this.user?.phone_nr === '+46707836535';
    },
    urlPath() {
      return this.$route.path;
    },
    onPartnerFullscreen() {
      return (/\/c-(activations|collections)\/[a-fA-F0-9]{24}/).test(this.$route.path);
    },
    partnerShell() {
      return this.authenticated && this.companyType && !this.onPartnerFullscreen;
    },
    // Shared by both router views, so legacy and shell-wrapped pages receive the same props and events.
    routerViewBindings() {
      return {
        serverVersion: this.serverVersion,
        onCloseSearch: this.closeSearch,
        onSetLoginView: (event) => this.setLoginView(event.view, event.step),
        onOpenSupportModal: (event) => this.openSupportModal(event.type, true),
        onOpenSubscribeModal: () => this.openSubscribeModal(),
        onOpenFaqModal: (event) => this.openFaqModal(event),
      };
    },
    showHomeButton() {
      const publicGoodiebag = this.goodiebag && this.goodiebag._id ? this.goodiebag.public : true;
      const publicOffer = this.offer && this.offer._id ? this.offer.public : true;
      const path = this.$route.path;
      return publicGoodiebag && publicOffer
        && (path.includes('/a/') || path.includes('/u-a/') || path.includes('/c/') || path.includes('/u-c/')
          || path.includes('/u-p/club'));
    },
    userType() {
      return this.isOnPartnerPage ? 'company' : (this.isOnAdminPage ? 'admin' : 'consumer');
    },
    showLogo() {
      if ((this.isOnOtherPage || this.isOnUserPage) && !this.isOnPvPage) {
        return true;
      } else if (!this.localCompany) {
        return false;
      } else {
        return !this.localCompany.hide_enginio_logo;
      }
    },
    hiddenEmailAdress() {
      if (this.emailadress) {
        const emailParts = this.emailadress.split('@');
        return `${'*'.repeat(emailParts[0].length - 3)}${emailParts[0].slice(emailParts[0].length - 3, emailParts[0].length)}@${emailParts[1]}`;
      }
      return '****@****';
    },
    hasSubscribed() {
      if (this.user?._id) {
        return !!this.user.accepted_merchandises?.some(company => company._id === this.localCompanyId);
      }
      return false;
    },
    missingMandatoryTerms() {
      const company = this.localCompany;
      if (!company) return false;
      const acceptedLists = {
        COMPANY_MERCHANDISE: this.user?.accepted_merchandises,
        COMPANY_SUBSCRIBE: this.user?.accepted_subscriptions,
      };
      const hasAccepted = type => !!acceptedLists[type]?.some(c => c._id === this.localCompanyId);
      const isMissing = (mandatory, type) => mandatory && !hasAccepted(type);
      return !!(isMissing(company.terms_mandatory, company.terms_type || 'COMPANY_MERCHANDISE')
        || isMissing(company.terms_2_mandatory, company.terms_2_type));
    },
    mandatoryTermsPromptCompanyId() {
      // Login (POST /nar/device) and several other endpoints return the bare user, without the accepted lists
      // that GET /users adds - wait for those instead of treating them as nothing accepted
      const loggedInUser = this.authenticated && this.user?._id
        && Array.isArray(this.user.accepted_merchandises) && Array.isArray(this.user.accepted_subscriptions);
      // Only on the brand's own pages - elsewhere (games, receipts, profile) localCompany can be the last visited brand
      const onCompanyPage = this.isOnBrandPage || this.isOnUserBrandPage || this.isOnUserClubPage;
      return loggedInUser && this.consumerType && onCompanyPage && this.missingMandatoryTerms ? this.localCompanyId : null;
    },
    // All these routes should be included in expectauthenticated
    expectAuthenticated() {
      return this.isOnUserLanding
        || this.isOnUserPage
        || this.isOnUserBrandPage
        || this.isOnPartnerPage
        || this.isOnAdminPage;
    },
    disabledNewUser() {
      return !this.formattedNr
        || (!this.firstName || this.firstName.length < 2)
        || (!this.lastName || this.lastName.length < 2)
        || (!this.emailadress || !this.emailadress.includes('@'))
        || !this.acceptterms
        || this.disabledCompanySubscribe;
    },
    disabledCompanySubscribe() {
      return (this.localCompany?.terms_mandatory && !this.companySubscribe)
        || (this.localCompany?.terms_2_mandatory && !this.companySubscribe2);
    },
    visibleNav() {
      if (this.isMarketPicker) {
        return false;
      } else if (this.isOnAdminPage || this.isOnPartnerPage || this.isHomePage) {
        return true;
      } else if (!this.loadedPageData) {
        return false;
      } else if (this.isOnUserPage || this.isHomePage) {
        return true;
      } else if (!this.localCompany || !this.localCompany._id) {
        return false;
      } else if (this.localCompany.hide_navigation) {
        return false;
      }
      return true;
    },
    cssProps() {
      return {
        '--regular-font-family': `${this.localCompany?.font_regular || 'CircularXXWeb-Regular'}`,
        '--medium-font-family': `${this.localCompany?.font_medium || 'CircularXXWeb-Medium'}`,
        '--bold-font-family': `${this.localCompany?.font_bold || 'CircularXXWeb-Bold'}`,

        '--brand-400-color': `${this.localCompany?.brand_400_color || '#ea7801'}`,
        '--brand-900-color': `${this.localCompany?.brand_900_color || '#ea7801'}`,
        '--brand-button-color': `${this.localCompany?.brand_button_color || '#ea7801'}`,
        '--nav-height': this.visibleNav ? '48px' : '0px',
      }
    },
    userInitials() {
      if (this.user && this.user.name && this.user.last_name) {
        return `${this.user.name.charAt(0)}${this.user.last_name.charAt(0)}`;
      }
      return '';
    },
  },
  watch: {
    loginModal(newVal) {
      const query = _cloneDeep(this.$route.query);
      if (!newVal) {
        query.login = undefined;
        this.$router.push({ query });
      } else {
        query.login = true;
        this.$router.push({ query });
      }
    },
    supportModal(newVal) {
      const query = _cloneDeep(this.$route.query);
      if (!newVal) {
        query.support = undefined;
        this.$router.push({ query });
      } else {
        query.support = true;
        this.$router.push({ query });
      }
    },
    subscribeModal(newVal) {
      // ?subscribe=true is an explicit request to show the modal, so it's only removed on close, never added
      if (!newVal && this.$route.query.subscribe) {
        const query = _cloneDeep(this.$route.query);
        query.subscribe = undefined;
        this.$router.push({ query });
      }
    },
    mandatoryTermsPromptCompanyId(newVal) {
      if (newVal) {
        console.log('[mandatoryTermsPromptCompanyId]', 'watcher', 'show subscribe modal');
        this.subscribeModal = true;
      }
    },
    company: {
      handler() {
        if (this.company && this.company._id) {
          const loggedInUser = this.authenticated && this.user && this.user._id;

          // only populated at company getter
          if (loggedInUser && this.consumerType
            && this.company.unlocked == false) {
            this.companyLockedModal = true;
            console.log('Company locked');
          }
        }
      },
      deep: true
    },
    localCompany: {
      handler() {
        this.mandatoryLogin = false;
        if (this.localCompany && this.localCompany._id) {
          this.companySubscribe = !!this.localCompany.terms_default;
          this.companySubscribe2 = !!this.localCompany.terms_2_default;

          if (this.localCompany.login_mandatory && !this.authenticated) {
            this.mandatoryLogin = true;
            // TODO: this.setLoginView('signupView'); depending of the company settings?
            this.setLoginView();
          }
        } else {
          this.companySubscribe = false;
          this.companySubscribe2 = false;
        }
      },
      deep: true
    },
    visibleNav() {
      document.body.style.setProperty('--nav-height', this.cssProps['--nav-height']);
    },
    authenticated(newVal, oldVal) {
      if (newVal !== oldVal && newVal && this.loginModal) {
        console.log('authenticated', 'dont try to login');
        this.setLoginView(false);
      }
    },
    theMarket(newVal) {
      if (newVal) {
        this.validateUser();
      }
    },
    /*loginModal(newVal) {
      let query = _cloneDeep(this.$route.query);
      if (!newVal) {
        query.loginView = undefined;
        query.signupView = undefined;
        this.loginView = false;
        this.whyIdfyedModalView = false;
        this.$router.push({ query });
      } else {
        if (this.loginView) {
          query.loginView = this.loginView;
        }
        if (this.signupView) {
          query.signupView = this.signupView;
        }
        this.$router.push({ query });
      }
    },
    signupView(newVal) {
      let query = _cloneDeep(this.$route.query);
      if (!newVal) {
        query.signupView = undefined;
        this.$router.push({ query });
      } else {
        query.signupView = true;
        this.$router.push({ query });
      }
    },
    loginView(newVal) {
      let query = _cloneDeep(this.$route.query);
      if (!newVal) {
        query.loginView = undefined;
        this.$router.push({ query });
      } else {
        query.loginView = true;
        this.$router.push({ query });
      }
    },*/
  },
  data() {
    return {
      imgHeaderMobile,
      loadedPage: false,
      bulletinDismissed: false,
      serverVersion: '1.0.0',
      currentYear: new Date().getFullYear(),
      isMobile,
      osName,
      browserName,
      mobileModel,
      currentUrl: location.href,
      showSnackbar: false,
      messageSnackbar: '',
      closeSnackbar: false,
      snackbarTop: '50%',
      snackbarBot: 'unset',
      snackbarLeft: '50%',
      snackbarRight: 0,
      snackbarTimeout: null,
      snackbarBackground: '',
      pageStatus: 'LOADING',
      selected: '',
      search: '',
      mobileSearch: false,
      changedRoute: false,
      newUserModal: false,
      mobileMenuOpen: false,
      desktopMenuOpen: false,
      // device ID
      loginModal: false,
      signupView: false,
      accepttermsModal: false,
      acceptterms: false,
      loginView: false,
      changePhoneView: false,
      phoneNrStep: true,
      altchaPayload: null,
      codeStep: false,
      emailStep: false,
      issueStep: false,
      loginIssue: '',
      loginCodeIssue: '',
      loginPhoneIssue: '',
      loginNewPhoneIssue: '',
      loginEmailIssue: '',
      deviceType: 'other',
      browserType: 'other',
      firstName: '',
      lastName: '',
      phoneNr: '',
      formattedNr: '',
      emailadress: '',
      oldPhoneNr: '',
      oldFormattedNr: '',
      verifyByEmail: false,
      validationCodePhone: undefined,
      validationCodeEmail: undefined,
      incompleteValidationCode: true,
      supportModal: false,
      supportSubject: '',
      supportName: '',
      supportLastName: '',
      supportPhoneNr: '',
      formattedSupportPhoneNr: '',
      supportOldPhoneNr: '',
      formattedSupportOldPhoneNr: '',
      supportEmail: '',
      supportDescription: '',
      cookieModal: false,
      subscribeModal: false,
      companyLockedModal: false,
      faqModal: false,
      faqTitle: 'FAQ',
      adblockModal: false,
      faqSubjects: [],
      faqQuestions: [],
      faqDisableSubject: false,
      isDevelopment: import.meta.env.MODE !== 'production',
      suggestions: {},
      collapsedNews: [false, false, false],
      companySubscribe: false,
      companySubscribe2: false,
      INTERCOM_ID: 'nxiq9ng3',
      mandatoryLogin: false,
      showCompanyWizard: false,
      showCollectionWizard: false,
      collectionWizard: {
        name: '',
        info: '',
        theme: null,
        background: null,
        logo: null,
        startPage: null,
      },
    };
  },
  methods: {
    ...mapMutations({
      setCompanyNumber: 'SET_COMPANY_NUMBER',
      setCompanyQuery: 'COMPANY_QUERY',
    }),
    async gotoInfo() {
      await this.$router.push({ name: 'HomeInfo' });
      this.resetModals();
    },
    async gotoData() {
      await this.$router.push({ name: 'HomeData' });
      this.resetModals();
    },
    findCompanies(query) {
      if (query !== '' && !this.$route.path.includes('u-st') && this.$route.path !== '/') {
        this.changedRoute = true;
        if (this.consumerType) {
          this.$router.push({ name: 'UserStart' });
        } else {
          this.$router.push({ name: 'Home' });
        }
      } else if (this.changedRoute && query === '') {
        this.$router.go(-1);
        this.changedRoute = false;
      }
      if (query !== '') {
        this.setCompanyNumber(20);
      } else {
        this.closeSearch();
        this.setCompanyNumber(8);
      }

      if (this.consumerType) {
        this.$store.dispatch('findUserCompanies', { query });
      } else {
        this.$store.dispatch('findNarCompanies', { query });
      }
    },
    closeSearch() {
      this.mobileSearch = false;
      if (this.changedRoute) {
        this.$router.go(-1);
        this.changedRoute = false;
        this.search = '';
        this.setCompanyQuery('');
      }
    },
    openSearch() {
      this.mobileSearch = true;
      setTimeout(() => {
        document.getElementById('companySearchInput').focus();
      }, 10);
    },
    acceptCookieModal() {
      localStorage.setItem(this.cookieModalVersion, true);
      localStorage.setItem('disableGTM', this.disableGTM);
      if (this.disableGTM) {
        this.gtag('consent', 'update', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied'
        });
      }
      this.pushDataLayer({
        parentCompany: 'None',
        company: 'None',
        goodiebag: 'None',
        offer: 'None',
        action: 'Enter Enginio first time',
      });
      this.cookieModal = false;
    },
    openCookieModal() {
      const acceptedCookies = localStorage.getItem(this.cookieModalVersion);
      if (!acceptedCookies) {
        this.cookieModal = true;
      }
    },
    disabledScrolling(reset) {
      if (reset) {
        document.body.style.overflow = '';
        document.body.style.height = '';
      } else {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
      }
    },
    setLoginView(view, step) {
      if (view) {
        this.disabledScrolling();
      } else if (!view && view !== undefined) {
        this.disabledScrolling(true);
      }
      if (!step) {
        if (view === 'signupView') {
          this.loginModal = true;
          this.signupView = true;
          this.loginView = false;
          this.changePhoneView = false;
        } else if (view === 'changePhoneView') {
          this.loginModal = true;
          this.signupView = false;
          this.loginView = false;
          this.changePhoneView = true;
        } else if (view === 'loginView') {
          this.loginModal = true;
          this.signupView = false;
          this.loginView = true;
          this.changePhoneView = false;
        } else if (view === false) {
          this.loginModal = false;
          this.signupView = false;
          this.loginView = false;
          this.changePhoneView = false;
        } else {
          this.loginModal = true;
          this.signupView = false;
          this.loginView = false;
          this.changePhoneView = false;
        }

        this.phoneNrStep = true;
        this.codeStep = false;
        this.emailStep = false;

        this.firstName = '';
        this.lastName = '';
        this.phoneNr = '';
        this.formattedNr = '';
        this.emailadress = '';
        this.oldPhoneNr = '';
        this.oldFormattedNr = '';
        this.validationCodePhone = '';
        this.validationCodeEmail = '';
        this.verifyByEmail = false;

        this.setLoginIssue(false, false);
      } else {
        if (step === 'codeStep') {
          this.phoneNrStep = false;
          this.codeStep = true;
          this.emailStep = false;
          this.verifyByEmail = false;

          this.setLoginIssue(false, false);

          if (this.wsReady) {
            this.$socket.on(`${this.formattedNr}_EMAIL`, () => {
              this.verifyByEmail = true;
            });
          }
        } else if (step === 'emailStep') {
          this.phoneNrStep = false;
          this.codeStep = false;
          this.emailStep = true;
          this.verifyByEmail = false;

          this.setLoginIssue(false, false);

          if (this.wsReady) {
            this.$socket.on(`${this.formattedNr}_EMAIL`, () => {
              this.verifyByEmail = true;
            });
          }
        }
      }
    },
    onAltchaVerified(event) {
      this.altchaPayload = event.detail.payload;
    },
    async signupGetCode() {
      if (!this.acceptterms) {
        this.accepttermsModal = !this.accepttermsModal;
        return;
      }
      if (this.disabledNewUser) {
        return;
      }

      if (!this.altchaPayload) {
        // background solve (auto="onload") hasn't finished yet - solve now as a fallback
        const result = await this.$refs.altchaWidget?.verify().catch(() => null);
        this.altchaPayload = result?.payload || null;
      }

      axios.post('/api/nar/device/phone', {
        parentCompany: this.localParentCompanyId,
        company: this.localCompanyId,
        activation: this.activation?._id,
        phoneNr: this.formattedNr,
        email: this.emailadress,
        name: this.firstName,
        lastName: this.lastName,
        deviceType: this.deviceType,
        browserType: this.browserType,
        subscribe: this.acceptterms,
        companySubscribe: this.companySubscribe,
        companySubscribe2: this.companySubscribe2,
        altcha: this.altchaPayload,
      })
      .then((response) => {
        return this.setLoginView(false, 'codeStep');
      })
      .catch((err) => {
        this.setErrorStep(err);
      });
    },
    async loginGetCode() {
      if (!this.altchaPayload) {
        // background solve (auto="onload") hasn't finished yet - solve now as a fallback
        const result = await this.$refs.altchaWidget?.verify().catch(() => null);
        this.altchaPayload = result?.payload || null;
      }

      axios.put('/api/nar/device/phone', {
        parentCompany: this.localParentCompanyId,
        company: this.localCompanyId,
        activation: this.activation?._id,
        phoneNr: this.formattedNr,
        deviceType: this.deviceType,
        browserType: this.browserType,
        altcha: this.altchaPayload,
      })
      .then(() => {
        this.setLoginView(false, 'codeStep');
      })
      .catch((err) => {
        this.setErrorStep(err);
      });
    },
    signupVerifyPhoneNr() {
      if (this.incompleteValidationCode || !this.validationCodePhone || this.validationCodePhone === '') {
        this.setAlert({ message: this.transl.routes.invalidcode, seconds: 3, close: 'OK' });
        this.setLoginIssue(this.transl.routes.invalidcode, 'CODE');
        return;
      }

      axios.post('/api/nar/device', {
        phoneNr: this.formattedNr,
        email: this.emailadress,
        name: this.firstName,
        lastName: this.lastName,
        validationCode: this.validationCodePhone,
        thirdPartyCrmName: this.thirdPartyCrmName,
        companyId: this.localCompanyId,
        goodiebagId: this.localGoodiebagId,
        offerId: this.offer._id,
        gameId: this.game._id,
      }).then((response) => {
        const { success = true, message, error } = response.data;
        if (!success) {
          const err = { response: { data: { message, error }}};
          this.setErrorStep(err);
        } else {
          this.setValidationCode();
          this.setLoginView(false, 'emailStep');
          if (this.wsReady) {
            this.$socket.on(`${this.user._id}_USER_UPDATE`, () => {
              this.redirectUser();
            });
          }
        }
      }).catch((err) => {
        this.setErrorStep(err);
      });
    },
    signupVerifyEmail() {
      if (this.incompleteValidationCode || !this.validationCodeEmail || this.validationCodeEmail === '') {
        this.setAlert({ message: this.transl.routes.invalidcode, seconds: 3, close: 'OK' });
        this.setLoginIssue(this.transl.routes.invalidcode, 'CODE');
        return;
      }

      this.$store.dispatch('signupLoginUser', {
        phoneNr: this.formattedNr,
        validationCode: this.validationCodeEmail,
        thirdPartyCrmName: this.thirdPartyCrmName,
        parentCompanyId: this.localParentCompanyId,
        companyId: this.localCompanyId,
        goodiebagId: this.localGoodiebagId,
        offerId: this.offer._id,
        gameId: this.game._id,
      }).then((response) => {
        const { success, message, error, newUser } = response;
        if (!success) {
          const err = { response: { data: { message, error }}};
          this.setErrorStep(err);
        } else {
          this.setValidationCode();
          this.setLoginView(false);
          this.setAlert({ message: this.transl.Login.yourelogin, seconds: 3, close: 'OK' });
          this.redirectUser(newUser);
        }
      })
    },
    loginVerifyPhoneNr() {
      if (this.incompleteValidationCode || !this.validationCodePhone || this.validationCodePhone === '') {
        this.setAlert({ message: this.transl.routes.invalidcode, seconds: 3, close: 'OK' });
        this.setLoginIssue(this.transl.routes.invalidcode, 'CODE');
        return;
      }

      this.$store.dispatch('loginUser', {
        phoneNr: this.formattedNr,
        validationCode: this.validationCodePhone,
        thirdPartyCrmName: this.thirdPartyCrmName,
        parentCompanyId: this.localParentCompanyId,
        companyId: this.localCompanyId,
        goodiebagId: this.localGoodiebagId,
        offerId: this.offer._id,
        gameId: this.game._id,
      }).then((response) => {
        const { success, message, error, newUser } = response;
        if (!success) {
          const err = { response: { data: { message, error }}};
          this.setErrorStep(err);
        } else {
          this.setValidationCode();
          this.setLoginView(false);
          this.setAlert({ message: this.transl.Login.yourelogin, seconds: 3, close: 'OK' });
          this.redirectUser(newUser);
        }
      });
    },
    async changePhoneNr() {
      if (!this.altchaPayload) {
        // background solve (auto="onload") hasn't finished yet - solve now as a fallback
        const result = await this.$refs.altchaWidget?.verify().catch(() => null);
        this.altchaPayload = result?.payload || null;
      }

      axios.put('/api/nar/device', {
        parentCompany: this.localParentCompanyId,
        company: this.localCompanyId,
        activation: this.activation?._id,
        phoneNr: this.oldFormattedNr,
        email: this.emailadress,
        newPhoneNr: this.formattedNr,
        deviceType: this.deviceType,
        browserType: this.browserType,
        altcha: this.altchaPayload,
      })
      .then(() => {
        this.setLoginView(false, 'codeStep');
      })
      .catch((err) => {
        this.setErrorStep(err);
      });
    },
    setValidationCode(code) {
      if (!code) {
        this.incompleteValidationCode = true;
        this.validationCodeEmail = '';
        this.validationCodePhone = '';
      } else {
        this.incompleteValidationCode = false;
        if (this.emailStep) {
          this.validationCodeEmail = code;
          this.signupVerifyEmail();
        } else {
          this.validationCodePhone = code;
          if (this.loginView) {
            this.loginVerifyPhoneNr();
          } else {
            this.signupVerifyPhoneNr();
          }
        }
      }
    },
    sendAnotherPhoneCode() {
      this.setLoginIssue(false, false);
      axios.put('/api/nar/device/code', {
        parentCompany: this.localParentCompanyId,
        company: this.localCompanyId,
        activation: this.activation?._id,
        phoneNr: this.formattedNr,
      })
      .then((response) => {
        this.setAlert({ message: response.data.message, seconds: 6, close: 'OK' });
      })
      .catch((err) => {
        this.setErrorStep(err);
      });
    },
    sendAnotherEmailCode() {
      this.setLoginIssue(false, false);
      axios.put('/api/nar/device/code/email', {
        parentCompany: this.localParentCompanyId,
        company: this.localCompanyId,
        activation: this.activation?._id,
        phoneNr: this.formattedNr,
        email: this.emailadress,
        name: this.firstName,
      })
      .then((response) => {
        this.setAlert({ message: response.data.message, seconds: 6, close: 'OK' });
      })
      .catch((err) => {
        this.setErrorStep(err);
      });
    },
    setErrorStep(err) {
      let message = 'Unknown issue, please contact Enginio support support@enginio.io';
      let error = '';
      let subject = '';
      if (err && err.response && err.response.data) {
        message = err.response.data.message || message;
        error = err.response.data.error || error;
        subject = err.response.data.subject || subject;
      }

      if (error === 'RETRY' || error === 'EXISTING' || error === 'SUPPORT' || error === 'VALIDATION') {
        this.setAlert({ message: message, seconds: 6, close: 'OK' });
      }
      this.setLoginIssue(message, subject);
    },
    setLoginIssue(message, subject) {
      this.loginIssue = '';
      this.loginCodeIssue = '';
      this.loginPhoneIssue = '';
      this.loginNewPhoneIssue = '';
      this.loginEmailIssue = '';
      if (!message && !subject) {
        this.issueStep = false;
        return;
      } else if (subject === 'CODE') {
        this.loginCodeIssue = message;
      } else if (subject === 'PHONE') {
        this.loginPhoneIssue = message;
      } else if (subject === 'NEW_PHONE') {
        this.loginNewPhoneIssue = message;
      } else if (subject === 'EMAIL') {
        this.loginEmailIssue = message;
      } else {
        this.loginIssue = message;
      }
      this.issueStep = true;
    },
    openSupportModal(type, closeModals = false) {
      if (closeModals) {
        this.resetModals();
      }
      this.supportModal = true;
      this.supportSubject = type;
    },
    onSignupTermsClick(event) {
      // The terms' contact link reloads the page with ?support=true, which would lose the signup form,
      // so open the support modal on top instead
      if (!event.target.closest('a[href="?support=true"]')) return;
      event.preventDefault();
      this.openSupportModal(this.transl.App.issuesignup);
    },
    openSubscribeModal() {
      this.resetModals();
      this.subscribeModal = true;
      console.log('[openSubscribeModal]', 'watcher', 'show subscribe modal');
    },
    openFaqModal({ faqSubjects, faqQuestions }) {
      this.resetModals();
      this.faqSubjects = faqSubjects;
      if (faqSubjects.length > 1) {
        this.faqTitle = 'FAQ';
        this.faqDisableSubject = false;
      } else {
        this.faqDisableSubject = true;
        this.faqTitle = this.transl.HomeFAQ[faqSubjects[0]];
      }
      this.faqQuestions = faqQuestions;
      this.faqModal = true;
    },
    resetModals() {
      this.setLoginView(false);
      this.supportModal = false;
      this.supportSubject = this.transl.issueother;
      this.cookieModal = false;
      this.subscribeModal = false;
      this.faqModal = false;
    },
    sendSupportCase() {
      const currentActivation = window.location.href;
      axios
        .post('/api/nar/support/email', {
          subject: this.supportSubject,
          name: this.supportName,
          lastName: this.supportLastName,
          phoneNr: this.formattedSupportPhoneNr,
          oldPhoneNr: this.formattedSupportOldPhoneNr,
          email: this.supportEmail,
          description: this.supportDescription,
          currentUrl: currentActivation,
        })
        .then(() => {
          this.supportModal = false;
          this.setAlert({ message: 'You have sent an support email, we will get back to you as fast as we can', seconds: 6, close: 'OK' });
        })
        .catch((err) => {
          this.setErrorStep(err);
        });
    },
    gotoCompanyHome() {
      let pushObj = { name: 'Home' };
      const path = this.$route.path;
      // always company for clubs
      if (this.localCompany?.club) {
        pushObj = { name: 'UserCompany', params: { companyId: this.getId(this.company) } };
      } else if (path.includes('/a/')) {
        pushObj = { name: 'HomeGoodiebag', params: { goodiebagId: this.getId(this.goodiebag) } };
      } else if (path.includes('/u-a/')) {
        pushObj = { name: 'UserGoodiebag', params: { goodiebagId: this.getId(this.goodiebag) } };
      } else if (path.includes('/c/')) {
        pushObj = { name: 'HomeCompany', params: { companyId: this.getId(this.company) } };
      } else if (path.includes('/u-c/')) {
        pushObj = { name: 'UserCompany', params: { companyId: this.getId(this.company) } };
      }
      this.$router.push(pushObj);
    },
    validateUser() {
      if (!this.theMarket) {
        this.loadedPage = true;
        return;
      }

      this.$store.dispatch('getUser')
      .then((response) => {
        const { success, version, status } = response;

        this.loadedPage = true;

        if (!success) {
          if (status === 404) {
            this.logout();
          } else {
            this.logoutRedirect();
          }
          return;
        }

        if (this.wsReady) {
          console.log('[validateUser]', 'User ready for WS messages');
          this.$socket.on(`TEST_WS_${this.user._id}`, () => {
            console.log('[validateUser]', 'WS message received');
            this.setAlert({ message: 'Succesfull WS connection test!', seconds: 30, close: 'OK' });
          });
        } else {
          console.error('WS connection failed!');
        }

        this.mandatoryLogin = false;

        this.setSupportData();
        this.userIntercom();
        this.redirectUser();
      });
    },
    redirectUser(newUser) {
      const path = window.location.pathname;

      if (this.companyType) {
        this.$store.dispatch('getNarPickedCompany').then((found) => {
          if (found) {
            this.$store.dispatch('getPickedCompany');
          } else {
            this.$router.push({ name: 'PartnerPicker' });
          }
        });
      } else if (this.adminType || this.consumerType) {
        const {
          subscribe = false
        } = this.$route.query;

        if (newUser) {
          this.newUserModal = true;
        }
        EventBus.emit('updateUser');

        if ((subscribe === true || subscribe === 'true') && this.localParentCompanyId) {
          console.log('[redirectUser]', 'subscribe', 'show subscribe modal');
          this.subscribeModal = true;
        }
        if (this.consumerType
          && !path.includes('/u-') && !path.includes('/a-') && !path.includes('/pv/')
          && !path.includes('/old-a')
          && !this.isOnOtherPage && !this.isOnGamePage) {
          let pushObj = { name: 'UserStart' };
          if (path.includes('/e/')) {
            const companyId = path.split('/e/')[1];
            pushObj = { name: 'UserCompany', params: { companyId } };
          } else if (path.includes('/c/') && this.goodiebag) {
            const goodiebagId = path.split('/c/')[1];
            pushObj = { name: 'UserGoodiebag', params: { goodiebagId } };
          } else if (path.includes('/a/') && this.offer) {
            const offerId = path.split('/a/')[1];
            pushObj = { name: 'UserOffer', params: { offerId } };
          }

          pushObj.query = {};
          if (newUser) {
            pushObj.query.newUser = true;
          }

          new URL(window.location.href).searchParams.forEach(function (value, key) {
            pushObj.query[key] = value;
          });
          this.$router.push(pushObj);
        }
      }
    },
    verifyEmail(queryObj) {
      const redirectObj = { name: 'UserStart', params: {}, query: queryObj };
      if (this.offer) {
        redirectObj.name = 'UserOffer';
        redirectObj.params = { offerId: this.offer._id };
      } else if (this.goodiebag) {
        redirectObj.name = 'UserGoodiebag';
        redirectObj.params = { goodiebagId: this.goodiebag._id };
      } else if (this.company) {
        redirectObj.name = 'UserCompany';
        redirectObj.params = { companyId: this.company._id };
      }
      localStorage.setItem('UserEmailRedirect', JSON.stringify(redirectObj));
      this.$router.push({ name: 'UserEmail' });
    },
    subscribeCompany(unsubscribeMerchandise) {
      this.$store.dispatch('subscribeCompany', {
        companyId: this.localCompanyId,
        companySubscribe: this.companySubscribe,
        companySubscribe2: this.companySubscribe2,
        unsubscribeMerchandise,
      }).then((message) => {
        this.subscribeModal = false;
        this.setAlert({ message, seconds: 3, close: 'OK' });
      });
    },
    feLogout() {
      this.$store.dispatch('logoutFeUser').then(() => {
        this.logoutRedirect();
      });
    },
    logout() {
      this.$store.dispatch('logoutUser').then(() => {
        this.logoutRedirect();
      });
    },
    logoutRedirect() {
      const path = this.$route.path;
      let pushObj = { name: 'Home' };
      let redirect = false;
      const query = { ...this.$route.query };
      if (this.isOnAdminPage) {
        redirect = true;
      } else if (this.isOnPartnerPage) {
        redirect = true;
        pushObj = { name: 'PartnerHome' };
      } else if (this.isOnUserLanding || this.isOnUserPage || this.isOnUserBrandPage) {
        redirect = true;
        if (path.includes('/u-e/')) {
          const companyId = path.split('/u-e/')[1];
          pushObj = { name: 'HomeCompany', params: { companyId } };
        } else if (path.includes('/u-c/') && this.goodiebag) {
          const goodiebagId = path.split('/u-c/')[1];
          pushObj = { name: 'HomeGoodiebag', params: { goodiebagId } };
        } else if (path.includes('/u-a/') && this.offer) {
          const offerId = path.split('/u-a/')[1];
          pushObj = { name: 'HomeOffer', params: { offerId } };
        }
      }
      pushObj.query = query;

      if (redirect) {
        this.$router.replace(pushObj);
      }
    },
    findSuggestions(query) {
      let companyId = undefined;
      let archived = false;
      let localPublic = true;
      if (this.companyType && this.company) {
        companyId = this.company._id;
        archived = undefined;
        localPublic = undefined;
      }
      this.$store.dispatch('search/findNarSuggestions', { query, companyId, archived, published: localPublic }).then(() => {
        this.suggestions = {
          Categories: this.searchGoodiebags,
          Items: this.searchOffers,
        };
      });
    },
    clickedSuggestion(data, consumer) {
      const { key, suggestion } = data;
      if (consumer && key === 'Categories') {
        this.$router.push({ name: 'HomeGoodiebag', params: { goodiebagId: this.getId(suggestion) } });
      } else if (consumer && key === 'Items') {
        this.$router.push({ name: 'HomeOffer', params: { offerId: this.getId(suggestion) } });
      } else if (key === 'Categories') {
        this.$router.push({ name: 'PartnerGoodiebag', params: { goodiebagId: this.getId(suggestion) } });
      } else {
        this.$router.push({ name: 'PartnerOffer', params: { offerId: this.getId(suggestion) } });
      }
    },
    onCopy() {
      this.setAlert({ message: this.transl.App.copy, seconds: 2, close: 'OK' });
    },
    onError() {
      this.setAlert({ message: this.transl.App.nocopy, seconds: 2, close: 'OK' });
    },
    setAlert({ message, seconds, type = 'info', close = false, /*top = '50%', bot = 'unset', left = '50%', right = 0*/ }) {
      this.messageSnackbar = message;
      this.closeSnackbar = close;
      if (type === 'warning') {
        this.snackbarBackground = 'rgba(231, 0, 149, 0.7)';
      } else if (type === 'error') {
        this.snackbarBackground = 'rgba(179, 0, 0, 0.7)';
      } else if (type === 'info') {
        this.snackbarBackground = 'rgba(0, 0, 0, 0.7)';
      }
      this.showSnackbar = true;
      clearTimeout(this.snackbarTimeout);
      this.snackbarTimeout = setTimeout(() => {
        this.showSnackbar = false;
      }, seconds * 1000);
    },
    devLogin() {
      axios.post('/api/nar/test-login').then(() => {
        this.validateUser();
      });
    },
    bootIntercomWidget() {
      let w=window;
      let ic=w.Intercom;
      let app = this;
      if (typeof ic==="function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        let d=document;
        let i=function () {i.c(arguments);};
        i.q=[];
        i.c=function (args) {i.q.push(args);};
        w.Intercom=i;
        let l=function() {
          let s=d.createElement('script');
          s.type='text/javascript';
          s.async=true;
          s.src=`https://widget.intercom.io/widget/${app.INTERCOM_ID}`;
          let x=d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s,x);
          w.Intercom('onShow', () => {app.userIntercom()});
        };

        if (document.readyState==='complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    },
    setSupportData() {
      this.supportName = this.user.name;
      this.supportLastName = this.user.last_name;
      this.formattedSupportPhoneNr = this.user.phone_nr;
      this.formattedSupportOldPhoneNr = this.user.phone_nr;
      this.supportEmail = this.user.email;
    },
    userIntercom() {
      try {
        window.Intercom('update', {
          app_id: this.INTERCOM_ID,
          email: this.user.email,
          phone_nr: this.user.phone_nr,
          user_id: this.user._id,
          market: this.countryCode,
          current_url: window.location.href,
          parent_company_id: this.localParentCompanyId,
          company_id: this.localCompanyId,
          company_name: this.localCompany?.name,
          collection_id: this.localGoodiebagId,
          collection_name: this.localGoodiebag?.name,
          offer_id: this.offer?._id,
          offer_name: this.offer?.name,
          pv_id: this.activation?._id,
          pv_name: this.activation?.name,
          receipt_id: this.receipts && this.receipts.length ? this.receipts[this.receipts.length-1]._id : '',
          created_at: this.user.created_at,
        });
      } catch (error) {
        console.error('userIntercom', error);
      }
    },
    toggleShowMore(element) {
      element[0] = !element[0];
    },
    switchCompany() {
      this.$store.dispatch('pickCompany', { pick: false }).then(() => {
        this.$router.replace({ name: 'PartnerPicker' });
      });
    },
    setCollectionWizardData(properties) {
      this.collectionWizard = {
        ...this.collectionWizard,
        ...properties
      };
    },
    async createNewCampaign(data) {
      await this.createCampaign(data);
      this.showCollectionWizard = false;
      this.$router.go();
    },
    resetCollectionWizardData() {
      this.collectionWizard = {
        name: '',
        info: '',
        theme: null,
        background: null,
        logo: null,
        startPage: null,
      };
    },
  },
};
</script>

<style lang="scss">
@use './assets/scss/style.scss';

$nav-height: var(--nav-height);

#control-height {
  height: 100vh;
  width: 0;
  position: absolute;
}

.bulletin-banner {
  position: sticky;
  top: 0;
  z-index: $zindex-sticky;
  width: 100%;
  height: fit-content;
  padding: 10px 40px 10px 16px;
  background-color: var(--brand-400-color);
  color: white;
  font-size: 14px;
  text-align: center;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (min-width: $big-screen-minwidth) {
    max-width: $desktop-medium-minwidth;
    margin: 0 auto;
  }

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
  }
}

// Custom hamburger drawers — no Vuetify layout dependency.
.hamburger-fade-enter-active,
.hamburger-fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.hamburger-fade-enter-from,
.hamburger-fade-leave-to {
  opacity: 0;
}

.hamburger-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;

  @media (max-width: 812px) {
    bottom: $nav-height;
  }
}

.hamburger-drawer {
  position: fixed;
  top: $nav-height;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10000;

  .hamburger-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 16px 4px 32px;
    min-height: 48px;
    height: 48px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }

  .a-line {
    margin: 0.5rem 1rem;
    border-bottom: 1px solid black;
  }
}

.hamburger-drawer--desktop {
  width: 350px;
  background: white;

  .hamburger-item {
    font-size: 16px;
  }

  .hamburger-big-header {
    padding: 2rem;
    font-size: 1.2rem;
    overflow-wrap: break-word;
    overflow: hidden;
    white-space: break-spaces;

    .header1 {
      color: black;
      font-family: var(--bold-font-family);
      font-weight: 600;
      font-size: 2rem;
      line-height: 20px;
      padding: 1rem 0;
      text-align: left;
    }
  }
}

.hamburger-drawer--mobile {
  left: 0;
  top: 0;
  bottom: $nav-height;
  width: 100%;
  background: rgb(255, 246, 247);
  display: flex;
  flex-direction: column;

  .hamburger-header {
    position: relative;
    color: white;
    font-size: 2rem;
    height: 172px;
    background: white;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    img {
      position: absolute;
      height: 60px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .left-bottom {
      font-weight: 600;
      position: absolute;
      bottom: 20px;
      left: 5vw;
      width: 90vw;
      min-width: 290px;
      overflow-x: clip;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.md-table-row{
  text-align: left;
  .md-table-cell-container{
    padding: 6px 10px 6px 10px;
  }
}

.create-account-logo {
  height: 30px !important;
}

.hamburger-footer {
  margin-top: 4rem;
  padding-left: 20px;
  font-size: 0.8rem;
  color: #666666;
  text-align: left;

  .hamburger-drawer--mobile & {
    margin-top: auto;
    padding-bottom: 1rem;
  }
  .copyright {}
  .version {
    margin-bottom: 10px;
  }
}

.hamburger-drawer .create-account-logo {
  height: 30px;
}

#companySearchInput {
  transition: all 1s ease-in-out;
  -webkit-transition: all 1s ease-in-out;
  -moz-transition: all 1s ease-in-out;
  -ms-transition: all 1s ease-in-out;
  -o-transition: all 1s ease-in-out;
  outline: none;
  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.068);
}

#companySearchInput:focus {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.137);
  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;
  border: 1px solid rgba(0, 0, 0, 0.062);
  border-radius: 24px;
}

.download-apps-wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr;

  @media (max-width: 992px) {
    padding: 0;
  }

  .download-appstore {
    display: inline-block;
    // padding: 1rem;
    cursor: pointer;
  }

  .download-googleplay {
    display: inline-block;
    cursor: pointer;

    @media (min-width: 992px) {
      // padding: 1rem;
    }
  }

  a {
    width: 100%;

    img {
      // margin: auto;
      display: block;
      height: 45px;

      @media (max-width: 992px) {
        padding: auto;
        height: unset;
      }
    }
  }
}

.download-mobile {
  display: block;

  .download-appstore {
    display: block;
    max-height: 50px;
    // margin: .5rem auto;
  }

  .download-googleplay {
    img {
      // padding: .8rem 6rem;
      max-height: 50px;
      display: block;
    }
  }
}

.button-idfyed-login {
  margin-top: 1rem;

  .md-button {
    display: block;
    margin: auto;
    color: white !important;
    background-color: #0e142b !important;
    border-radius: 6px;
    max-width: 400px;
  }
}

.m-input-phone-number {
  max-width: 100%;
  box-sizing: border-box;

  .m-phone-input {
    min-width: 0 !important;
  }

  .m-input-phone-number__country-select {
    min-width: 130px;

    .m-select-country__select .m-input-wrapper {
      border-bottom-left-radius: 10px !important;
      // border-bottom-left-radius: var(--maz-radius, 0.5rem) !important;
    }
  }
}

.modal-view {
  overflow: hidden;
  border-radius: 8px !important;
  position: absolute;
  top: 0;

  .close-login-modal-button {
    position: sticky;
    justify-content: flex-end;
    top: 0;
    z-index: 1;
    background: white;
    width: 100%;
    padding: 10px 0px 5px;
    display: flex;
    cursor: pointer;
  }

  .login-absolute-stamp {
    width: 50px;
  }

  .modal-view-steps {
    padding: 1rem 2rem;

    .step {
      display: grid;
      grid-template-columns: 1fr 6fr;
      grid-gap: 1rem;
      margin: 1.5rem 0;

      .step-number {
        position: relative;
        display: inline-block;
        border-radius: 50%;
        background: $brand-yellow;
        color: white;
        height: 30px;
        width: 30px;

        @media (max-width: 812px) {
          height: 25px;
          width: 25px;
        }

        div {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .modal-why-content {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr 10fr;
    padding: 1rem 0.5rem;

    .modal-why-header {
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
  }

  .modal-view-join {
    margin-top: 1rem;
    margin-bottom: 2rem;
    text-align: center;
    cursor: pointer;
    text-decoration: underline;
  }

  .modal-view-why {
    padding: 1rem 0;
    text-align: center;
    background: #e0e0e0;
    font-weight: 600;
    cursor: pointer;
  }

  .modal-view-why2 {
    color: white;
    background: $brand-yellow;
  }

  .login-content {
    touch-action: pan-y;

    .input-field--container {
      margin-bottom: 16px;
    }

    .vuephoneinput-container {
      margin-bottom: 16px;
      .flex {
        height: 57px;
      }

      .small-text-bold {
        margin: 10px 0;
      }
    }

    .login-header {
      display: flex;
      flex-direction: column;

      .login-header-logo {
        width: 100px;
        border-radius: 50%;
        margin: auto;
        background-color: black;
        z-index: 10000000;
        position: absolute;
        top: -50px;
        z-index: 1;
        place-self: center;
      }

      .modal-view-subheader-text {
        margin: 10px 0;
      }
    }

    .--login-back {
      display: grid;
      grid-template-columns: 0.4fr 1.6fr 0.4fr;
      grid-gap: 8px;
      align-items: center;
      justify-content: flex-start;

      h3 {
        white-space: normal;
      }

      .back-button--container {
        align-self: center;
        width: 40px;
        height: 40px;
        margin: 17px 17px 17px 0;
        background: $brand-white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .--signup-header-text {
        text-align: left;
        word-break: break-word;
      }

      .--signup-step {
        color: gray;
        margin-left: 5px;
      }

      .login-absolute-stamp {
        width: 50px;
        margin-left: auto;
      }
    }

    .login-signup-step {
      color: $brand-grey;
    }

    .login-signup-body {
      text-align: center;
    }

    .login-verification-step {
      position: relative;
      border-radius: 8px;
      background-color: $brand-white;
      margin: 25px 0;
      padding: 40px 1rem 0 1rem;
      text-align: center;
      height: 150px;

      .back-button--container {
        width: 40px;
        height: 40px;
        margin: auto;
        margin-bottom: 5px;
        background: #f8f8f8;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #CCCCCC;
        padding: 0.2rem;
        position: absolute;
        left: 39%;
        top: 0;
        transform: translate(+50%, -50%);
        background-color: white;
        border-radius: 50%;
        border: style.$icon-border;
        -webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.03);
        -moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.03);
        box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.03);
        cursor: pointer;
      }

      .pininput-wrapper {
        margin-top: 10px;
      }


      .validation-input {
        margin-top: 1rem;
        width: unset !important;
      }
    }

    .login-issue-text {
      color: red;
    }

    .login-issue-or-text {
      font-size: 1rem;
      padding: 1rem;
      font-weight: 600;
      text-align: center;
    }

    .login-description {
      text-align: center;
      color: $brand-grey;
    }

    .btn-icon-text {
      color: var(--brand-button-color) !important;
    }

    // buttons and input fields
    .input-field--container.--container-checkbox {
      input {
        border-color: var(--brand-button-color);
      }
    }
    .input-field--container.--container-checkbox.--container-focused-filled {
      input {
        background: var(--brand-button-color);
      }
    }
    .input-field--container.--container-filled.--container-focused-filled {
      input.--focused {
        border-color: var(--brand-button-color) !important;
      }
    }
  }

  .company-header-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .--accept-terms {
      // TODO: change
      margin-top: 20px;
      margin-bottom: 10px;
      // font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.001em;

      .md-checkbox {
        margin: 4px 16px 16px 0;
      }

      .--company-subscribe-description {
        text-align: left;
        // margin-top: 10px;
        margin-bottom: 30px;
      }

      .--confirm-terms,
      .--newsletter,
      .--company-subscribe {
        display: grid;
        grid-template-columns: 20px 1fr;
        grid-gap: 10px;
        align-items: flex-start;
        text-align: left;
        max-width: 95%;
        @media (min-width: 812px) {
          max-width: 85%;
        }

        input {
          margin-top: 4px;
        }
        .--text {
          margin-bottom: 20px;
          margin-left: 10px;

          .--bold-text {
            font-family: var(--medium-font-family);
            font-weight: bold;
          }

          .clickable-link {
            font-family: var(--bold-font-family);
            font-weight: 400;
          }

          .--expanded-text {
            div {
              margin-bottom: 10px;
            }

            .--bold-expanded-text {
              font-family: var(--medium-font-family);
              font-weight: bold;
              color: #333333;
            }

            .--grey-expanded-text {
              font-family: var(--regular-font-family);
              font-weight: 400;
              color: #999999;
            }

            .--regular-expanded-text {
              font-family: var(--regular-font-family);
              font-weight: 400;
            }

            span {
              font-family: var(--regular-font-family);
              font-weight: 400;
            }
          }

          .-show-less,
          .-show-more {
            cursor: pointer;
            font-family: var(--medium-font-family);
            color: #333333;
          }
        }
      }

      .mandatory-description {
        font-style: italic;
        color: #616161
      }
    }

  .--signup-container {
    .--signup-content {
      text-align: left;
      .--inputs-and-error {
        .login-signup-body {
          margin-bottom: 10px;
          text-align: left;
        }
        .--inputs-container {
          padding: 25px 12px;
          background: $brand-white;
          border-radius: 8px;

          .login-issue-text {
            margin-top: 30px;
          }
        }
      }
    }

    .--terms {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 12;
      background: white;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 60px;
      position: absolute;
      padding: 24px 16px;
      overflow: auto;
      border-radius: 10px;

      .-header-container {
        /*background: white;
        position: fixed;
        height: 60px;
        width: 90%;*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cross {
          place-self: flex-start;
        }

        h3 {
          padding: 24px 0;
        }
      }

      /*.body-terms{
        padding: 17px;
        background: $brand-white;
        border-radius: 8px;
        margin: 50px 0 80px 0;
      }*/

      .body-1 {
        padding: 17px;
        background: $brand-white;
        border-radius: 8px;
        margin-bottom: 80px;
      }

      .btn {
        width: 90%;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
      }

      &::before {
        content: '';
        position: fixed;
        bottom: 0;
        transform: translateY(1px);
        left: 0;
        background: white;
        width: 100%;
        height: 55px;
        padding: 20px;
        border-radius: 0 0 10px 10px;
      }
    }

    .--buttons-container {
      .--tech-issues {
        padding: 17px 0;
      }

      .--continue-btn {
      }

      .--or-btns {
      }
    }
  }

  .--login-container {
    .--content {
      .body-1 {
        padding: 16px 0;
        text-align: center;
      }

      .--input-container {
        background: $brand-white;
        border-radius: 8px;
        padding: 24px 24px 34px;
        .m-input-phone-number {
          display: flex !important;
        }

        .input-field--container {
          margin-bottom: 16px !important;
        }

        .login-issue-text {
          margin-top: 30px;
        }
      }

      .--buttons-container {
        .--tech-issues {
          margin-top: 14px;
        }

        .--continue-btn {
          margin-top: 32px;
        }

        .--or-btns {
        }
      }
    }

    .--verify-and-login {
      text-align: center;

      .confetti {
        margin: 25px 0;
      }
    }

    @media (min-width: 1020px) {
      width: auto;
    }
  }

  .--new-number-container {
    text-align: left;
    .--login-back {
      h3 {
        width: auto;
      }
    }
    .--content {
      .small-text {
        margin: 16px 0 10px;
        color: #111111;
        font-weight: 700;
      }

      .login-issue-text {
        margin-top: 30px;
      }

      .--choose-verify {
        .--input-container {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: space-between;
          margin-bottom: 25px;

          .input-field--container {
            margin-bottom: 16px !important;
          }
        }
      }

      .--verify-number,
      .--verify-email {
        background: $brand-white;
        border-radius: 8px;

        .--old-num,
        .--fill-email {
          display: flex;
          flex-direction: column;
          padding: 10px 16px;
        }

        .--new-num {
          padding: 0 16px 25px;
        }
      }

      .--fill-email {
        .login-issue-text {
          margin-top: 0;
        }
      }

      .--buttons-container {
        .--tech-issues {
          margin-top: 14px;
        }

        .--continue-btn {
          margin-top: 32px;
        }

      }
    }
  }

  .--login-menu-container {
    .--logo-container {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        border: 0.5px solid #cccccc;
        background: white;
        border-radius: 50%;
        max-width: 100px;
        position: absolute;
        top: -50px;
        z-index: 1;
      }
    }
  }

  @media (min-width: 1020px) {
    overflow: unset;
  }
}

.--faq-modal {
  .question-container {
    box-shadow: none;
  }

  .collapsable-content {
    padding: 0;
  }

  .modal-container {
    background: white;
    border-radius: 10px;
    .modal-header {
      h3 {
        font-weight: 700;
        font-size: 22px;
      }
    }
  }
}

.md-overlay {
  z-index: 9 !important;
}

.cookie-modal {
  position: fixed;
  bottom: 0;
  background-color: white;
  width: 100%;
  font-size: 14px;
  z-index: 1000000000;

  .cookie-modal-content {
    margin: auto;
    padding: 2rem 1rem;
    max-width: 1100px;

    @media (min-width: 812px) {
      display: grid;
      grid-template-columns: 2fr 1fr;
    }
    .cookie-header {
      display: inline-flex;
      margin-bottom: 10px;
      i {
        margin-right: 10px;
      }
    }

    .cookie-modal-text {
      text-align: left;
      padding: 0 1rem;
    }
    .cookie-modal-confirm-toggle {
      display: grid;
      .input-field--container {
        justify-self: center;
        .--toggle-label {
          text-align: left !important;
        }
      }
    }
    .cookie-modal-confirm-toggle.show-desktop {
      .input-field--container {
        justify-self: left;
      }
    }
    .cookie-modal-confirm {
      display: grid;
      align-items: end;
      .btn {
        // max-width: 200px;
      }
    }
  }
}

/*.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}*/
</style>

<style lang="scss" scoped>
@use "../src/assets/scss/pages/App";
</style>
